import * as enums from '@worldfavor/constants/enums'
import dateFns from 'date-fns'
import { getEnterpriseLoginSpecifications, getEnterpriseLoginRouteNames } from '@worldfavor/portal/scripts/wf/authentication/enterpriseLogin'

(function () {
    'use strict'

    let currentWorldfavorUserId // Temp solution

    angular.module('wf', [
        'wf.common',
        'wf.data',
        'wf.templates',
        'ui.router',
        'angular-storage',
        'angular-jwt',
        'ngResource',
        'ngSanitize',
        'ngAnimate',
        'ui.bootstrap',
        'ui.select',
        'theme.core.panels',
        'theme.core.directives',
        'theme.core.navigation_controller',
        'theme.core.notifications_controller',
    ])
        .config(['lockProvider', '$stateProvider', '$urlRouterProvider', '$httpProvider', '$compileProvider', '$provide', '$locationProvider', 'jwtOptionsProvider',
            function(lockProvider, $stateProvider, $urlRouterProvider, $httpProvider, $compileProvider, $provide, $locationProvider, jwtOptionsProvider) {
                'use strict'

                // (function (_win) {
                // 	// Combined list of commands in Chrome Dev Tools (Stable/Canary) and FireBug
                // 	var consoleCommands = [ "assert", "clear", "count", "debug", "dir", "dirxml", "error", "exception", "group", "groupCollapsed", "groupEnd", "info", "log", "profile", "profileEnd", "time", "timeEnd", "timeStamp", "table", "trace", "warn" ];

                // 	_win.console = {};
                // 	for (var i = 0, len = consoleCommands.length; i < len; i++) {
                // 		_win.console[consoleCommands[i]] = function () {};
                // 	}
                // 	// if (typeof _win.console === "undefined") {
                // 	// }
                // 	// else
                // 	// {
                // 	// 	for (var i = 0, len = consoleCommands.length; i < len; i++) {
                // 	// 		if (typeof _win.console[consoleCommands[i]] === "undefined")
                // 	// 			_win.console[consoleCommands[i]] = function () { };
                // 	// 	}
                // 	// }
                // })(window);

                //Moment.js global changes
                moment.updateLocale('en', {
                    week: {
                        dow: 1,
                    },
                })

                moment.updateLocale('sv', {
                    week: {
                        dow: 1,
                    },
                })

                $compileProvider.preAssignBindingsEnabled(true)
                $compileProvider.debugInfoEnabled(false)
                // $compileProvider.commentDirectivesEnabled(false);
                // $compileProvider.cssClassDirectivesEnabled(false);

		let apiVersionUsageMessage

		if ($.proxies.baseUrl === "https://dev.api1.worldfavor.com/") {
			apiVersionUsageMessage = 'Using dev API\n(dev db)'
		}
		else if ($.proxies.baseUrl === "https://staging.api1.worldfavor.com/") {
			apiVersionUsageMessage = 'Using staging API\n(prod db)'
		}
		else if ($.proxies.baseUrl === "http://localhost:5000/") {
			apiVersionUsageMessage = 'Using localhost API'
		}

		if (apiVersionUsageMessage) {
			$("body").prepend($("<div class='visible-lg'>" + apiVersionUsageMessage + "</div>").css({
				color: "red",
				position: "fixed",
				zIndex: 10000000000,
				top: 5,
				left: 5,
				fontWeight: 500,
				whiteSpace: 'pre-wrap',
			}))
		}

                configureRoutes($stateProvider, $urlRouterProvider, $locationProvider)

                // authProvider.init({
                // 	domain: 'worldfavor.eu.auth0.com',
                // 	clientID: 'OfxP4kGpndPic3A6veHNy6JYGQQdD1Py',
                // 	loginState: 'login'
                // });

                configureAuth0Lock(lockProvider)

                jwtOptionsProvider.config({
                    whiteListedDomains: ['https://api25.worldfavor.com'],
                    tokenGetter: ['wfAuth', function(wfAuth) {
                        // Return the saved token
                        return wfAuth.getToken()
                    }],
                })

                $httpProvider.interceptors.push('jwtInterceptor')

                // If not on portal.worldfavor.com then add cache busting querystring to all html template ajax requests.
                // Not on portal.worldfavor.com means localhost, alpha, beta and widgets (widgets are run from customers own corporate domains).
                // Precompiled templates are used on portal.worldfavor.com.
                if (process.env.NODE_ENV === 'development' || window.wf__embeddedWidgetMode) {
                    (function () {
                        $httpProvider.interceptors.push(() => {
                            const
                                loadedTemplates = {}

                            let cacheBustVersion

                            return {
                                request(config) {
                                    let url = config.url
                                    // Check is to avoid breaking AngularUI ui-bootstrap-tpls.js: "template/accordion/accordion-group.html"
                                    if (!~url.indexOf('template/') && (~url.indexOf('scripts/') || ~url.indexOf('views/') && ~url.indexOf('.html'))) {
                                        if (!loadedTemplates[url]) loadedTemplates[url] = new Date().getTime()
                                        cacheBustVersion = loadedTemplates[url]
                                        // Append ?v=[cacheBustVersion] to url
                                        url += (url.indexOf('?') === -1 ? '?' : '&')
                                        url += '_=' + cacheBustVersion
                                        url = '/' + url

                                        config.url = url
                                    }

                                    return config
                                },
                            }
                        })
                    })()
                }

                configureJQueryAjax()

                // If Angular is loaded in widget mode then the modal will be have a different container
                // so a delegate is added to fix scrollbars issue on html/body element
                if (window.wf__embeddedWidgetMode) {
                    $provide.decorator('$uibModal', ['$delegate', function($delegate) {
                        const
                            open = $delegate.open

                        const html = $('html')

                        const body = $('body')

                        const htmlValueOfOverflowY = html.css('overflowY')

                        const bodyValueOfOverflowY = body.css('overflowY')

                        $delegate.open = function () {
                            const modalInstance = open(...arguments)

                            modalInstance.opened.then(() => {
                                html.css({ overflowY: 'hidden' })
                                body.css({ overflowY: 'hidden' })
                            })

                            modalInstance.closed.then(() => {
                                html.css({ overflowY: htmlValueOfOverflowY })
                                body.css({ overflowY: bodyValueOfOverflowY })
                            })

                            return modalInstance
                        }

                        return $delegate
                    }])
                }

                $provide.decorator('$uibModal', ['$delegate', function($delegate) {
                    const open = $delegate.open

                    $delegate.open = function (options) {
                        var
                            options = arguments[0]

                        let modalInstance

                        const additionalWindowClass = 'wf-modal fade-in-and-scale-up'

                        if (options.windowClass) options.windowClass += ' ' + additionalWindowClass
                        else options.windowClass = additionalWindowClass

                        modalInstance = open(...arguments)

                        return modalInstance
                    }

                    return $delegate
                }])

                $provide.decorator('$ngBootbox', ['$delegate', function($delegate) {
                    const customDialog = $delegate.customDialog

                    $delegate.customDialog = function (options) {
                        var
                            options = arguments[0]

                        let modalInstance

                        const additionalClassName = 'wf-modal fade-in-and-scale-up'

                        if (options.className) options.className += ' ' + additionalClassName
                        else options.className = additionalClassName

                        modalInstance = customDialog(...arguments)

                        return modalInstance
                    }

                    return $delegate
                }])

                $provide.decorator('$translate', ['$delegate', '$q', function($delegate, $q) {
                    let
                        getter

                    const instant = $delegate.instant

                    const delegate = $delegate

                    const useLanguage = $delegate.use

                    let translationCache = {}

                    getter = function (translationId, interpolateParams, interpolationId, defaultTranslationText, forceLanguage) {
                        let deferred; let output

                        if (!interpolationId && !defaultTranslationText && !forceLanguage) {
                            deferred = $q.defer()
                            output = $delegate.instant(translationId, interpolateParams)

                            if (translationId.indexOf('.') !== -1 && output === translationId) deferred.reject()
                            else deferred.resolve(output)
                            // console.log("use CACHE", translationId, interpolateParams);

                            return deferred.promise
                        }
                        else {
                            // console.log("use default", translationId, interpolateParams);
                            return delegate(...arguments)
                        }
                    }

                    $delegate.instant = function(translationId, interpolateParams, interpolationId, forceLanguage, sanitizeStrategy) {
                        let output
                        if (_.isEmpty(interpolateParams) && !interpolationId && !sanitizeStrategy) {
                            if (translationCache[translationId]) {
                                // console.log("translate [FROM CACHE]", translationId);
                                output = translationCache[translationId]
                            }
                            else {
                                // console.log("translate for real", translationId);
                                output = translationCache[translationId] = instant(translationId)
                            }
                        }
                        else output = instant(...arguments)

                        // console.log(output);

                        return output
                    }

                    $delegate.use = function (langKey) {
                        translationCache = {}
                        useLanguage(langKey)
                    }

                    return _.assign(getter, $delegate)
                }])
            }])
        .run(['$rootScope', 'store', 'jwtHelper', '$state', 'wfObject', 'dataOperationsService', 'DS', '$timeout', '$translate', 'signalR', 'wfAuth', '$templateCache', '$http', '$location', 'modalService', '$window', 'amMoment',
            function ($rootScope, store, jwtHelper, $state, wfObject, dataOps, DS, $timeout, $translate, signalR, wfAuth, $templateCache, $http, $location, modal, $window, amMoment) {
                const statesWithoutAuthRequirement = [
                    'login',
                    'login-link',
                    'login-sms',
                    'login-code',
                    'auth0-login-callback',
                    'account-activateUser',
                    'signup',
                    // "public"
                ]
                let usePublicAuthentication = false
                let useSustRoomAuthentication = false
                let useInfluenceRoomAuthentication = false
                let usePublicProfileAuthenticated = false
                let sustainabilityRoomId = null
                let influenceRoomId = null
                let usePasswordlessLogin = false; let passwordlessLoginInProgress = false
                let lock; let hash
                let loadingAuthenticatedUser = false

                Array.prototype.push.apply(statesWithoutAuthRequirement, getEnterpriseLoginRouteNames())

                $rootScope.appVersionInfo = '260625.0747'
                if ($rootScope.appVersionInfo.indexOf('@@') === 0) {
                    $rootScope.appVersionInfo = dateFns.format(new Date(), 'YYMMDD[.]HHmm')
                }
                else {
                    console.log('Version ' + $rootScope.appVersionInfo)
                }

                // This hooks all auth events to check everything as soon as the app starts
                wfAuth.handleAuthentication()

                // TODO remove this dead code if not used anymore
                if (!true && typeof window.Auth0LockPasswordless !== 'undefined') { // This code is for Lock v9. Disabled with !true

                    lock = new Auth0LockPasswordless('OfxP4kGpndPic3A6veHNy6JYGQQdD1Py', 'worldfavor.eu.auth0.com')
                    hash = lock.parseHash(window.location.hash)
                }

                if (hash && hash.error) {
                    console.log('There was an error with Auth0 passwordless signin: ' + hash.error + '\n' + hash.error_description)
                } else if (hash && hash.id_token) {
                    usePasswordlessLogin = true
                }
                let currentToState; let currentToParams; let currentToOptions

                // This events gets triggered on refresh or URL change
                $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
                    let
                        isAuthenticated = false

                    usePublicAuthentication = false
                    useSustRoomAuthentication = false
                    useInfluenceRoomAuthentication = false
                    usePublicProfileAuthenticated = false
                    sustainabilityRoomId = null
                    influenceRoomId = null

                    currentToState = null
                    currentToParams = null

                    // if (passwordlessLoginInProgress)
                    // {
                    // 	console.log("preventDefault");
                    // 	event.preventDefault(); // Prevents the router from navigating to the state
                    // }

                    if (!passwordlessLoginInProgress && !_.includes(statesWithoutAuthRequirement, toState.name))
                    {
                        // Clear JSData cache
                        clearCacheFromState(event, toState, toParams, fromState, fromParams)

                        if (usePasswordlessLogin && !passwordlessLoginInProgress) {
                            passwordlessLoginInProgress = true
                            usePasswordlessLogin = false
                            console.log('usePasswordlessLogin')

                            DS.clear() // Clear all cached data in JSData
                            dataOps.clearCachedRequests()
                            $rootScope.isLoggedIn = false

                            store.set('token', hash.id_token)

                            //retrieve profile
                            // console.log("get profile")
                            lock.getProfile(hash.id_token, (err, profile) => {
                                if (err) {
                                    //handle err
                                    console.log(err)
                                    $rootScope.logOut()
                                } else {
                                    //use user profile
                                    // console.log(profile);
                                    store.set('profile', profile)

                                    $timeout(() => {
                                        // console.log("go to org page");
                                        passwordlessLoginInProgress = false
                                        $rootScope.isLoggedIn = true
                                        auth.authenticate(profile, hash.id_token)
                                        if (profile.wf_orgId > 0) $state.go('root')
                                        else $state.go('accountOrganizations')
                                    }, 500)
                                }
                            })

                            event.preventDefault() // Prevents the router from navigating to the state
                        }
                        else
                        {
                            // Check authentication
                            isAuthenticated = (function () {
                                if (wfAuth.isAuthenticated()) {
                                    $rootScope.isLoggedIn = true

                                    if (wfAuth.triggerAuthEvent()) {
                                        currentToState = toState
                                        currentToParams = toParams
                                        event.preventDefault()
                                    }

                                    return true
                                }
                                else
                                {
                                    // event.preventDefault(); // Prevents the router from navigating to the state

                                    // $rootScope.isLoggedIn = true;
                                    // setTimeout(function (params) {
                                    // 	// setTimeout is used so that listeners for "auth0.loginSuccess" have time to be set.
                                    // 	$rootScope.$emit("auth0.loginSuccess", null, true);

                                    // 	setTimeout(function () {
                                    // 		if (toState.name === "dataRelation") {
                                    // 			toParams.idPath = toParams.objectId || toParams.idPath.split("/").reverse()[0];
                                    // 		}
                                    // 		$state.go(toState.name, toParams);
                                    // 	}, 600);
                                    // }, 500);

                                    return false
                                }
                            })()

                            if (toState.name == 'room') {
                                if (!$rootScope.isLoggedIn) useSustRoomAuthentication = true

                                sustainabilityRoomId = parseInt(toParams.roomId) // Not used?
                                wfAuth.initPublic()
                            }
                            else if (toState.name == 'room.child') {
                                if (!$rootScope.isLoggedIn) useSustRoomAuthentication = true

                                sustainabilityRoomId = parseInt(toParams.roomId) // Not used?
                                wfAuth.initPublic()
                            }
                            else if (toState.name == 'public') {
                                if (!$rootScope.isLoggedIn) useInfluenceRoomAuthentication = true

                                // influenceRoomId = parseInt(toParams.roomId); // Not used?
                                wfAuth.initPublic()
                            }
                            else if (toState.name == 'public-influence') {
                                if (!isAuthenticated) usePublicProfileAuthenticated = true
                            }
                            else if (!isAuthenticated)
                            {
                                event.preventDefault() // Prevents the router from navigating to the state
                                let encodedPathname

                                if (toState.name === 'file-download') {
                                    encodedPathname = encodeURIComponent(document.location.pathname + document.location.search)
                                }

                                $rootScope.logOut(encodedPathname) // Signs out and redirects to login page
                            }
                            else
                            {
                                // wfAuth.init();
                            }
                        }
                    }
                    else if (toState.name == 'public')
                    {
                        usePublicAuthentication = true
                        wfAuth.initPublic()
                    }
                })

                $rootScope.$on('$stateChangeSuccess', (event, toState, toParams, fromState, fromParams) => {
                    // console.log("Intercom update");
                    intercomEvent('update')

                    if (typeof window.ga !== 'undefined') window.ga('send', 'pageview', $location.path())
                })

                $.ajaxPrefilter((options, originalOpts, jqXHR) => {
                    const
                        dfd = $.Deferred()

                    const authToken = wfAuth.getToken()

                    const authHeaderValue = wfAuth.getAuthenticationHeaderValue()

                    const setAdditionalHeaders = function (xhr) {
                        if (options.url.indexOf('zapier.com') === -1) xhr.setRequestHeader('Cache-Control', 'no-cache')
                    }

                    if (options.url.indexOf($.proxies.baseUrl) !== 0) {
                        options.beforeSend = function (xhr) {
                            setAdditionalHeaders(xhr)
                        }
                        return
                    }

                    // if the request works, return normally
                    jqXHR.done(dfd.resolve)

                    //if (!options.beforeSend) {
                    //console.log("no before send");
                    //console.info(localStorage.getItem('token'));
                    if (authToken && $rootScope.isLoggedIn) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', 'Bearer ' + authToken)
                            setAdditionalHeaders(xhr)
                        }
                    }
                    else if (usePublicAuthentication) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', 'public')
                            setAdditionalHeaders(xhr)
                        }
                    }
                    else if (useSustRoomAuthentication) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', authHeaderValue)
                            setAdditionalHeaders(xhr)
                        }
                    }
                    else if (useInfluenceRoomAuthentication) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', authHeaderValue)
                            setAdditionalHeaders(xhr)
                        }
                    }
                    else if (usePublicProfileAuthenticated) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', authHeaderValue)
                        }
                    }
                    else if (authHeaderValue) {
                        options.beforeSend = function (xhr) {
                            xhr.setRequestHeader('Authorization', authHeaderValue)
                            setAdditionalHeaders(xhr)
                        }
                    }
                    else {
                        options.beforeSend = function (xhr) {
                            setAdditionalHeaders(xhr)
                        }
                    }
                    //}
                    //else {
                    //	console.log(options.beforeSend);
                    //}

                    jqXHR.fail(function(failResult) {
                        // if (jqXHR.status >= 500 || jqXHR.status === 401)
                        // {
                            displayInternalServerError(failResult.responseJSON, options, jqXHR)
                            dfd.rejectWith(this, arguments)
                        // }
                    })

                    return dfd.promise(jqXHR)
                })

                // $rootScope.$on('auth0.loginSuccess', function (event, authContext, reauthenticated) {
                // 	doPostAuthentication(reauthenticated);
                // });

                wfAuth.onAuthenticated(doPostAuthentication)

                $rootScope.$on('auth0.logout', () => {
                    // console.log("Intercom shutdown");
                    intercomEvent('shutdown')
                    intercomEvent('boot', { app_id: 'gei2qraz' })
                    wfAuth.clear()
                    signalR.disconnect()
                })

                if (document.location.hostname === 'localhost' || document.location.hostname === 'local.worldfavor.com') {

                    // Preload some required templates. When project is built it's not needed because templates are precompiled
                    const toggleDirectiveTemplateUrl = 'scripts/wf/common/toggle.directive.html'
                    $http.get(toggleDirectiveTemplateUrl).then((res) => {
                        $templateCache.put(toggleDirectiveTemplateUrl, res.data)
                    })

                    const metadataDefaultDirectiveTemplateUrl = 'scripts/wf/objectMetadata/wfObjectMetadata.directive.html'
                    $http.get(metadataDefaultDirectiveTemplateUrl).then((res) => {
                        $templateCache.put(metadataDefaultDirectiveTemplateUrl, res.data)
                    })

                    const metadataVerticalDirectiveTemplateUrl = 'scripts/wf/objectMetadata/wfObjectMetadataList.directive.html'
                    $http.get(metadataVerticalDirectiveTemplateUrl).then((res) => {
                        $templateCache.put(metadataVerticalDirectiveTemplateUrl, res.data)
                    })
                }

                $rootScope.goToStateAfterAuthenticated = function(toState, toParams, options) {
                    currentToState = toState
                    currentToParams = toParams
                    currentToOptions = options

                    if (!loadingAuthenticatedUser) gotoPendingRoute()
                }

                function gotoPendingRoute() {
                    if (currentToState) $state.go(currentToState, currentToParams, currentToOptions)
                }

                function doPostAuthentication(event, authContext, reauthenticated, userInfo, token, options) {
                    const culture = wfAuth.getCulture()
                    const redirectPathAfterLogin = localStorage.getItem('redirectPathAfterLogin')
                    localStorage.removeItem('redirectPathAfterLogin')

                    let skipNormalLoadingAndRedirectTo

                    if (location.pathname.includes('/login') && location.search.indexOf('?redirect=') === 0) {
                        skipNormalLoadingAndRedirectTo = decodeURIComponent(decodeURIComponent(location.search.split('=')[1]))
                    }
                    else if (redirectPathAfterLogin) {
                        skipNormalLoadingAndRedirectTo = decodeURIComponent(redirectPathAfterLogin)
                    }
                    else if (location.pathname.includes('/file')) {
                        skipNormalLoadingAndRedirectTo = true
                    }

                    if (skipNormalLoadingAndRedirectTo) {
                        loadingAuthenticatedUser = false
                        $rootScope.isLoggedIn = true
                        $rootScope.initialLoadingAfterLogin = false
                        $rootScope.onAuthenticated && $rootScope.onAuthenticated()

                        if (typeof skipNormalLoadingAndRedirectTo === 'string') {
                            document.location = skipNormalLoadingAndRedirectTo
                        }
                        else {
                            gotoPendingRoute()
                        }
                        return
                    }

                    const intercomPayload = {
                        app_id: 'gei2qraz',
                        user_id: wfAuth.getAuth0UserId(),
                        auth0_id: wfAuth.getAuth0UserId(),
                        culture: wfAuth.getCulture(),
                        name: undefined, // Set after getting user from server
                        email: wfAuth.getUserEmail(),
                        created_at: undefined, // Set after getting user from server
                    }

                    let orgId

                    let auth0UserId

                    let gotoStateAfterLogin

                    $rootScope.isLoggedIn = true
                    signalR.reconnect(token)

                    if (culture == 'en-US' || culture == 'sv-SE' || typeof culture === 'string') {

                        if (culture == 'sv-SE' || culture == 'en-US') {
                            $translate.use(culture)
                        }
                        else {
                            $translate.use('en-US')
                        }

                        switch (culture) {
                            case 'sv-SE':
                                moment.locale('sv')
                                amMoment.changeLocale('sv')
                                numeral.locale('sv')
                                break
                            case 'en-US':
                            default:
                                moment.locale('en')
                                amMoment.changeLocale('en')
                                numeral.locale('en')
                                break
                        }
                    }
                    else {
                        $translate.use('sv-SE')
                        moment.locale('sv')
                        amMoment.changeLocale('sv')
                        numeral.locale('sv')
                    }

                    window.wf = {}
                    window.wf._u = currentWorldfavorUserId = wfAuth.getWorldfavorUserId()
                    window.wf._o = orgId = wfAuth.getOrganizationId()

                    auth0UserId = wfAuth.getAuth0UserId()

                    window.__wf_sfErrorMessageProvider.setDefaultMessage(302, $translate.instant('validationMessages.required'))
                    window.__wf_sfErrorMessageProvider.setDefaultMessage(200, $translate.instant('validationMessages.stringTooShort'))

                    if (!reauthenticated) {
                        dataOps.create({
                            type: 88,
                        }).then((res) => {
                            // console.info(res);
                        })

                        if ($rootScope.gotoStateAfterLogin) {
                            gotoStateAfterLogin = $rootScope.gotoStateAfterLogin
                            $rootScope.gotoStateAfterLogin = undefined
                        }
                    }

                    loadingAuthenticatedUser = true
                    $rootScope.initialLoadingAfterLogin = true

                    dataOps.getObject({
                        objectType: 100,
                        objectId: currentWorldfavorUserId,
                        auth0UserId,
                    }).then((user) => {
                        intercomPayload.name = user.name
                        intercomPayload.created_at =  moment(user.created_at).format('x') // Unix timestamp;

                        wfAuth.assignAuthUserValues({
                            name: user.name,
                            email: user.email,
                            given_name: user.given_name,
                            family_name: user.family_name,
                            imageUrl: user.imageUrl,
                            phone_number: user.phone_number,
                            culture: user.culture,
                            position: user.position,
                        })

                        if (!reauthenticated) {
                            if (!options || !options.skipNavigating) {
                                if (orgId) {
                                    if (gotoStateAfterLogin) {
                                        $state.go(gotoStateAfterLogin.stateName, gotoStateAfterLogin.stateParams)
                                    }
                                    else $state.go('root')
                                }
                                else $state.go('root')
                            }
                        }

                        if (typeof window.Bugsnag !== 'undefined') {
                            Bugsnag.user = {
                                id: currentWorldfavorUserId,
                                auth0_id: auth0UserId,
                                name: user.name, // Full name
                                email: user.email, // Email address
                            }
                        }

                        intercomEvent('shutdown')

                        if (orgId) {

                            // Get organization
                            dataOps.getObject({
                                objectType: 101,
                                objectId: orgId,
                                skipExtras: true,
                            }).then((org) => {
                                // Get networks
                                // console.log(wfObject.get("71-11009"));
                                if (typeof window.Bugsnag !== 'undefined') {
                                    Bugsnag.user.org_id = orgId
                                    Bugsnag.user.org_name = org.name
                                }
                                wfAuth.setOrganization(org)

                                // Get root object
                                dataOps.getObject('71-10010', {
                                    objectId: 10010,
                                    objectType: 71,
                                    childrenLoadDepth: 3,
                                    skipExtras: true,
                                }).then((rootObject) => {

                                    $timeout(() => {
                                        wfAuth.assignAuthUserValues({
                                            organizationName: org.name,
                                            orgIsTemporary: org.organizationType === enums.organizationType.temporary,
                                        })

                                        gotoPendingRoute()
                                        loadingAuthenticatedUser = false
                                        $rootScope.initialLoadingAfterLogin = false
                                        $rootScope.onAuthenticated && $rootScope.onAuthenticated()
                                    })

                                    dataOps.getObject({
                                        objectType: 71,
                                        objectId: 11009,
                                        bypassCache: true,
                                        getterConditions: {
                                            loadCreators: false,
                                        },
                                    }).then((networkStructure) => {
                                        intercomPayload.company = {
                                            id: org.id,
                                            name: org.name,
                                            'Root Object Title': (rootObject.childContent || {}).title,
                                            'Root Object WFID': rootObject.wfid,
                                        }

                                        const networkIds = networkStructure.childs.map(x => x.childId).sort((a, b) => a - b)
                                        intercomPayload.company['Networks'] = networkIds.length ? `|${networkIds.join('|')}|` : ''

                                        // Only initiate Intercom if org type is not temporary
                                        if (wfAuth.getRootStructureInfo().name !== 'insights') {
                                            intercomEvent('boot', intercomPayload)

                                            if (window.plantrack) {
                                                plantrack.identify(currentWorldfavorUserId, { email: user.email, name: user.name, companyExternalId: org ? org.id : undefined })

                                                if (!reauthenticated) {
                                                    plantrack.track('Logged in', org ? { companyExternalId: org.id } : undefined)
                                                }
                                            }

                                            //getting list of industries for an organization
                                            const orgSettingStructure = wfObject.get('71-14490')
                                            if (orgSettingStructure) {
                                                dataOps.getObject('71-14409', { onlyStatistics: true }).then((res) => {
                                                    if (!org.name || !(org.registrationNumber || org.vatNumber) || !org.countryId || !org.employeeCountSpan || _.get(res, 'metadata.statistics.count') === 0) $state.go('intro', null, { location: 'replace' })
                                                })
                                            }
                                        }
                                    })
                                })
                            }, () => {
                                // Error
                                // intercomEvent("boot", intercomPayload);
                            })
                        }
                        else { // No organization - only signed in as a person
                            gotoPendingRoute()
                            loadingAuthenticatedUser = false
                            $rootScope.initialLoadingAfterLogin = false
                            // Don't initiate Intercom - only when org is signed in
                            // intercomEvent("boot", intercomPayload);
                            $rootScope.onAuthenticated && $rootScope.onAuthenticated()
                        }
                    })
                }

                function clearCacheFromState(event, toState, toParams, fromState, fromParams) {
                    let
                        wfid1

                    let wfid2

                    let dataRelationObj

                    let orgDataRelations

                    let organizations

                    let orgIds

                    if (fromParams.objectType && fromParams.objectId)
                    {
                        wfid1 = fromParams.objectType + '-' + fromParams.objectId
                        if (fromParams.objectType == 73)
                        {
                            dataRelationObj = wfObject.get(wfid1)
                            if (dataRelationObj)
                            {
                                // console.log("Before clearing", wfObject.getAll().length);
                                // console.time("Selective cache clearing");

                                wfid2 = dataRelationObj.wfcid
                                orgDataRelations = wfObject.filter({ type: 73, childType: 101, wffid: wfid2 }) // Get dataRelation with organization child and the given object as parent

                                if (orgDataRelations.length > 0)
                                {
                                    dataOps.eject(wfid1) // Eject dataRelation from request cache
                                    dataOps.eject(wfid2) // Eject structure from request cache
                                    orgIds = _.map(orgDataRelations, 'wfcid')
                                    wfObject.ejectAll({ where: { type: 101, wfid: { in: orgIds } } }) // Eject all organizations that are a child of the given object
                                    wfObject.ejectAll({ where: { type: 73, childType: 101, wfcid: { in: orgIds } } }) // Eject dataRelations with all the organizations as child
                                    wfObject.ejectAll({ type: 13 }) // Eject influences
                                }

                                // console.timeEnd("Selective cache clearing");
                                // console.log("After clearing", wfObject.getAll().length);
                                // console.log("---");
                            }
                        }
                    }
                }

                let errorAlertModalShowing = false

                function displayInternalServerError(res, opts, jqXHR) {
                    const
                        textColor = 'inherit'
                    // wf.isLocal ? "#bbb" : "inherit",

                    const labelCss = 'color:' + textColor + ';font-family:Segoe UI;font-size:13px;font-weight:bold;border:0;line-height:1.7em'

                    const originalResult = res

                    if (!res || !res.StackTrace) return

                    if (res.InnerException)
                    {
                        // res = res.InnerException;
                        while (res.InnerException)
                        {
                            res = res.InnerException
                        }
                    }

                    if (!errorAlertModalShowing && res && res.ExceptionType === 'Auth0.Core.Exceptions.ApiException' && !_.includes(opts.data, 'suppressErrorMessage=true')) {
                        errorAlertModalShowing = true

                        modal.alert({
                            title: $translate.instant('errorMessages.serverError.title'),
                            message: $translate.instant('errorMessages.serverError.message'),
                            onEscape: false,
                            type: 'info',
                            buttons: {
                                reload: {
                                    label: $translate.instant('errorMessages.reloadButtonCaption'),
                                    className: 'btn-hollow action',
                                    callback() {
                                        location.reload()
                                    },
                                },
                            },
                        })
                    }

                    try
                    {
                        //WF_WebApp.webservices.ws_general.logWebServiceError({
                        //	exception: res,
                        //	wsClass: wsClass,
                        //	wsMethod: wsMethod,
                        //	wsParams: {},
                        //	href: document.location.href,
                        //	wfUser: wf.user
                        //}, function () {
                        //	if (typeof console !== "undefined") console.log('WebService Error logged.');
                        //});
                        if (typeof window.Bugsnag !== 'undefined') {
                            // Argument1: Error type
                            // Argument2: Error message
                            // Argument3: Metadata object
                            //		On Bugsnags error details the properties of the metadata object is handled like this:
                            //		- All properties of type string/number/boolean will be collected in a "Custom" tab as a list of key-value-pairs
                            //		- All properties of type object/array will be shown as individual tabs containing lists of key-value-pairs
                            Bugsnag.notify(
                                '[ServerError] ' + res.ExceptionType, res.ExceptionMessage,
                                {
                                    'Server Exception': (function () {
                                        const
                                            output = {}

                                        let exception = originalResult

                                        let nestedCounter = 0

                                        while (exception) {
                                            if (nestedCounter == 0) {
                                                _.each(exception, (value, key) => {
                                                    if (key !== 'InnerException') output['_' + key] = value
                                                })
                                            }
                                            else {
                                                _.each(exception, (value, key) => {
                                                    if (key !== 'InnerException') output['inner' + nestedCounter + '_' + key] = value
                                                })
                                            }

                                            exception = exception.InnerException
                                            nestedCounter++

                                            if (nestedCounter === 20) break
                                        }

                                        return output
                                    })(),
                                    XHR: {
                                        _method: opts.type,
                                        _status: jqXHR.status,
                                        _statusText: jqXHR.statusText,
                                        _url: opts.url,
                                        contentType: opts.contentType,
                                        data: (function () {
                                            try {
                                                return JSON.parse('{"' + decodeURI(opts.data).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')
                                            }
                                            catch (e) {
                                                return opts.data
                                            }
                                        })(),
                                    },
                                },
                            )
                        }

                        {
                            res.ExceptionMessage = res.ExceptionMessage.replace(/to use near '/gi, 'to use near \'\n').replace(/' at line /gi, '\n\' at line ')
                            console.group('%cError during AJAX request', 'color:' + textColor + ';font-family:Segoe UI;font-size:15px;font-weight:bold;border:0;line-height:1.7em')

                            //console.group("%cWeb service", labelCss);
                            console.log('%c' + opts.type + ' ' + opts.url, 'line-height:2em')
                            //console.groupEnd();

                            console.group('%cMessage', labelCss)
                            console.log('%c' + res.ExceptionMessage, 'color:#F14D38;font-weight:bold;font-style:normal')
                            console.groupEnd()

                            console.group('%cType', labelCss)
                            console.log('%c' + res.ExceptionType, 'color:' + textColor + ';')
                            console.groupEnd()

                            console.groupCollapsed('%cStack trace', labelCss)
                            console.log('%c' + (res.StackTrace && res.StackTrace.replace(/ {3}/gi, '').replace(/:line /gi, '_LINE:').replace(/(?=[:\\])(.*)(?=\\WF_WebApp)/, ':\\...')), 'color:' + textColor + ';background:inherit;float:none;width:auto;clear:both;display:block;font-size:11px;')
                            console.groupEnd()

                            console.groupCollapsed('%cJavaScript stack trace', labelCss)
                            console.trace()
                            console.groupEnd()

                            console.groupCollapsed('%cPassed data (' + typeof opts.data + ')', labelCss)
                            console.log(opts.data)
                            console.groupEnd()

                            console.groupCollapsed('%cAjax options', labelCss)
                            console.log(opts)
                            console.groupEnd()

                            console.groupCollapsed('%cjqXHR', labelCss)
                            console.log(jqXHR)
                            console.groupEnd()
                            console.groupEnd()
                        }
                    }
                    catch (e)
                    {
                        console.groupEnd()
                        console.groupEnd()
                        console.groupEnd()
                        console.groupEnd()
                        console.log('Exception thrown when displaying internal server error.', e)

                    }
                }

                $rootScope.setPublicLayoutClass = function() {
                    if ($rootScope.usePublicLayout
					|| $rootScope.useDarkModePublicLayout
					|| $rootScope.useWhiteModePublicLayout) {
                        $(document.body).addClass('layout-public')
                    }
                    else {
                        $(document.body).removeClass('layout-public')
                    }
                }
            },
        ])

    function intercomEvent(eventName, payload) {
        if (!window.wf__embeddedWidgetMode && typeof window.Intercom === 'function') {
            window.Intercom(eventName, payload)
        }
    }

    function initHubSpot(user) {
        const deferred = $.Deferred()

        const scriptElement = document.createElement('script')
        scriptElement.id = 'hs-script-loader'
        scriptElement.type = 'text/javascript'
        scriptElement.src = '//js.hs-scripts.com/2989273.js'
        document.head.appendChild(scriptElement)

        scriptElement.addEventListener('load', () => {
            setTimeout(() => {
                // _hsq.push(["identify", {
                // 	email: user.email,
                // 	id: user.id,
                // 	firstname: user.given_name,
                // 	lastname: user.family_name,
                // 	phone: user.phone_number,
                // }]);
                deferred.resolve()
            }, 1000)
        })

        return deferred.promise()
    }

    function configureJQueryAjax() {
        $.support.cors = true
        $.ajaxSetup({
            cache: false,
            crossDomain: true,
            contentType: 'application/json; charset=utf-8',
            // Note: dataType: "json" should not be added because some requests only returns status OK 200 without any response body.
            // jQuery parser then will fail since it expects a json response.
            xhrFields: {
                withCredentials: false, // This setting passes cookies along the request, including our authentication cookie.
            },
        })

        /*
		Below code adds an ajaxTransport function (a jQuery Ajax decorator) to enable requests that returns binary data
		-------------------------------------
		Credit: http://www.henryalgus.com/reading-binary-files-using-jquery-ajax/

		General info:
		jQuery still does not support HTML5 XMLHttpRequest Level 2 binary data type requests.

		jQuery allows us to create Ajax transports – plugins, which are created to make custom Ajax requests.
		The idea is to make a "binary" Ajax transport. This Ajax transport creates new XMLHttpRequest and passes all the received data back to the jQuery.

		For this script to work correctly, processData must be set to false, otherwise jQuery will try to convert received data into string, but fails.
		Example:
		$.ajax({
			url: "/my/image/name.png",
			method: "POST",
			dataType: "binary",
			processData: false,
			success: function(result){
				// result is of type Blob
			}
		});
		*/
        $.ajaxTransport('+binary', (options, originalOptions, jqXHR) => {
            // check for conditions and support for blob / arraybuffer response type
            if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob)))))
            {
                return {
                    // create new XMLHttpRequest
                    send(headers, callback) {
                        // setup all variables
                        const xhr = new XMLHttpRequest()

                        const url = options.url

                        const type = options.type

                        const async = options.async || true

                        // blob or arraybuffer. Default is blob

                        const dataType = options.responseType || 'blob'

                        const data = options.data || null

                        const username = options.username || null

                        const password = options.password || null

                        xhr.addEventListener('load', () => {
                            const data = {}
                            data[options.dataType] = xhr.response
                            // make callback and send data
                            callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders())
                        })

                        xhr.open(type, url, async, username, password)

                        // setup custom headers
                        for (const i in headers) {
                            xhr.setRequestHeader(i, headers[i])
                        }

                        xhr.responseType = dataType
                        xhr.send(data)
                    },
                    abort() {
                        jqXHR.abort()
                    },
                }
            }
        })
    }

    function configureAuth0Lock(lockProvider) {
        const domain = 'dev.legacy.auth.worldfavor.com'
        const audience = 'https://api25.worldfavor.com'
        const usingDevTenant = ''

        const enterpriseLoginSpecs = getEnterpriseLoginSpecifications()
        const lockOptions = getLockOptions()

        enterpriseLoginSpecs.forEach((x) => {
            if (x.authButtonTheming) {
                lockOptions.options.theme.authButtons[x.connection] = x.authButtonTheming
            }
        })

        lockProvider.init(lockOptions)

        function getLockOptions() {
            return {
                domain,
                clientID: 'nhxpTSO6UDzeecXdBjMtHvhj7gCBmBb5',
                options: {
                    // Old options for Lock v9
                    // disableSignupAction: true,
                    // disableResetAction: false,
                    // closable: false,
                    // connections: [ 'Username-Password-Authentication', 'martinservera-waad' ],
                    // authParams: {
                    // 	scope: 'openid email nickname picture wf_userId wf_orgId wf_orgName currentOrgAttempt isAdmin name culture' // Specify the scopes you want to retrieve
                    // },
                    // icon: '/assets/img/logos/worldfavor_logo_black.svg',

                    // configurationBaseUrl: "https://api25.worldfavor.com/utility/auth0ClientConfig", // https://auth0.com/docs/custom-domains/additional-configuration#embedded-lock
                    configurationBaseUrl: (function () {
                        const offset = new Date().getTimezoneOffset()
                        if (offset / 60 == -8) { // Check if China timezone
                            // https://cdn.eu.auth0.com does not work in China so we use a proxy.
                            // Sometimes the proxy fail because the Auth0 server did not respond so we minimize the possibility for that error by checking the timezone

                            // From backend stacktrace:
                            // <Error>
                            // <Message>An error has occurred.</Message>
                            // <ExceptionMessage>An error occurred while sending the request.</ExceptionMessage>
                            // <ExceptionType>System.Net.Http.HttpRequestException</ExceptionType>
                            // <StackTrace>
                            // at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at WorldfavorWebAPI_25.Controllers.UtilityController.<GetAuth0ClientConfiguration>d__13.MoveNext() in D:\a\1\s\WorldfavorWebAPI-25\Controllers\UtilityController.cs:line 615 --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Threading.Tasks.TaskHelpersExtensions.<CastToObject>d__3`1.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Web.Http.Controllers.ApiControllerActionInvoker.<InvokeActionAsyncCore>d__0.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__5.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Web.Http.Filters.ActionFilterAttribute.<CallOnActionExecutedAsync>d__5.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Web.Http.Filters.ActionFilterAttribute.<ExecuteActionFilterAsyncCore>d__0.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Web.Http.Controllers.ActionFilterResult.<ExecuteAsync>d__2.MoveNext() --- End of stack trace from previous location where exception was thrown --- at System.Runtime.CompilerServices.TaskAwaiter.ThrowForNonSuccess(Task task) at System.Runtime.CompilerServices.TaskAwaiter.HandleNonSuccessAndDebuggerNotification(Task task) at System.Web.Http.Dispatcher.HttpControllerDispatcher.<SendAsync>d__1.MoveNext()
                            // </StackTrace>
                            // <InnerException>
                            // <Message>An error has occurred.</Message>
                            // <ExceptionMessage>Unable to connect to the remote server</ExceptionMessage>
                            // <ExceptionType>System.Net.WebException</ExceptionType>
                            // <StackTrace>
                            // at System.Net.HttpWebRequest.EndGetResponse(IAsyncResult asyncResult) at System.Net.Http.HttpClientHandler.GetResponseCallback(IAsyncResult ar)
                            // </StackTrace>
                            // <InnerException>
                            // <Message>An error has occurred.</Message>
                            // <ExceptionMessage>
                            // A connection attempt failed because the connected party did not properly respond after a period of time, or established connection failed because connected host has failed to respond 54.230.29.203:443
                            // </ExceptionMessage>
                            // <ExceptionType>System.Net.Sockets.SocketException</ExceptionType>
                            // <StackTrace>
                            // at System.Net.Sockets.Socket.EndConnect(IAsyncResult asyncResult) at System.Net.ServicePoint.ConnectSocketInternal(Boolean connectFailure, Socket s4, Socket s6, Socket& socket, IPAddress& address, ConnectSocketState state, IAsyncResult asyncResult, Exception& exception)
                            // </StackTrace>
                            // </InnerException>
                            // </InnerException>
                            // </Error>
                            return 'https://api1.worldfavor.com/utility/auth0ClientConfig'
                        }
                        else {
                            return 'https://cdn.eu.auth0.com'
                        }
                    })(),

                    // Display
                    autoclose: true,
                    closable: false,
                    allowedConnections: ['Username-Password-Authentication'],
                    rememberLastLogin: true,

                    // Database
                    allowForgotPassword: true,
                    allowSignUp: false,
                    mustAcceptTerms: true,
                    allowAutocomplete: false,

                    // Authentication
                    _enableIdPInitiatedLogin: true,
                    auth: {
                        sso: !window.wf__embeddedWidgetMode, // If loaded as a widget then SSO must be false otherwise CORS error will be thrown. lockProvider.init must still be called otherwise the injected lock service will fail in other places.
                        responseType: 'token id_token', // Read about different tokens: https://auth0.com/docs/tokens
                        audience,
                        redirect: true, // Needed here to enable popup mode

                        // Must be in the list of allowed callback URLs in Worldfavor client settings page in Auth0. Can't use location.origin in IE10
                        redirectUrl: location.protocol + '//' + location.hostname + (location.port && location.port.length ? ':' + location.port : '') + '/login-callback',
                        // Auth0 always does an initial /authorize request when the page loads and if redirectUrl is undefined here
                        // the current page url is used which will cause 403 Forbidden response if the url is not in the list of allowed callback URLs.
                        // A trailing slashes in the list of allowed callback URLs are ignored.
                        params: {
                            // Arbitrary props can not be put here. Auth0 shows a warning in the console and the will not authenticate.
                            // Read about custom claims: https://auth0.com/docs/scopes/current#custom-claims
                            state: btoa(JSON.stringify({ signInAsOrgId: null })), // This is decoded and parsed in an Auth0 rule
                            scope: 'openid email name wf_userId wf_orgId wf_orgName isAdmin culture role', // Does not affect the scope of the initial SSO /authorize request
                            nonce: ('crypto' in window || 'msCrypto' in window) ? undefined : (function (length) { // If browser doesn't support Web Crypto API (IE10) then mock the nonce
                                let text = ''
                                const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
                                for (let i = 0; i < length; i++) {
                                    text += possible.charAt(Math.floor(Math.random() * possible.length))
                                }
                                return text
                            })(32),
                        },
                    },

                    // https://auth0.com/docs/libraries/lock/v11/configuration#additionalsignupfields-array-
                    additionalSignUpFields: [
                        {
                            name: 'given_name',
                            placeholder: 'first name',
                            // The following properties are optional
                            icon: 'https://worldfavordata.blob.core.windows.net/misc/Auht0Lock_SignUpIcon_fa-user-o.png',
                            validator(value) {
                                return {
                                    valid: value.length,
                                    // hint: "Can't be blank" // optional
                                }
                            },
                        },
                        {
                            name: 'family_name',
                            placeholder: 'last name',
                            // The following properties are optional
                            icon: 'https://worldfavordata.blob.core.windows.net/misc/Auht0Lock_SignUpIcon_fa-user-o.png',
                            validator(value) {
                                return {
                                    valid: value.length,
                                    // hint: "Can't be blank" // optional
                                }
                            },
                        },
                        {
                            name: 'phone_number',
                            placeholder: 'phone number (optional)',
                            // The following properties are optional
                            icon: 'https://worldfavordata.blob.core.windows.net/misc/Auht0Lock_SignUpIcon_ion-phone.png',
                            validator(value) {
                                return {
                                    valid: true,
                                }
                            },
                        },
                    ],

                    // Theming
                    theme: {
                        logo: '/assets/img/logos/worldfavor_logo_black.svg',
                        primaryColor: '#3498db', // @wf_blue
                        authButtons: {},
                    },

                    // https://github.com/auth0/lock/blob/master/src/i18n/en.js
                    languageDictionary: {
                        databaseEnterpriseLoginInstructions: '<span style="font-size: 12px;white-space: nowrap;">By logging in you accept the <a href="https://worldfavor.com/terms-conditions/" target="_blank" style="color:#3498db">Terms &amp; Conditions</a></span>',
                        enterpriseLoginIntructions: '<strong>Login with your corporate credentials.</strong><hr style="margin:7px 0" /><span style="font-size: 12px;white-space: nowrap;">By logging in you accept the <a href="https://worldfavor.com/terms-conditions/" target="_blank" style="color:#3498db">Terms &amp; Conditions</a></span>',
                        lastLoginInstructions: '<span style="font-size: 12px;white-space: nowrap;">By logging in you accept the <a href="https://worldfavor.com/terms-conditions/" target="_blank" style="color:#3498db">Terms &amp; Conditions</a></span><hr style="margin:7px 0" /><strong>Last time you logged in with</strong>',
                        title: (usingDevTenant ? '[DEV] ' : '') + 'Worldfavor',
                        signUpTerms: 'By creating an account you agree to the<br />Worldfavor <a href="https://worldfavor.com/terms-conditions/" target="_blank" style="color:#3498db">Terms & Conditions</a> and <a href="https://worldfavor.com/privacy-policy/" target="_blank" style="color:#3498db">Privacy Policy</a>.',
                        error: {
                            signUp: {
                                'lock.fallback': 'Something went wrong during sign up.<br />Please log in if you already have an account registered.',
                            },
                        },
                        success: {
                            forgotPassword: 'If an account with this email exists, an email to reset your password will be sent.',
                        },
                    },
                },
            }
        }
    }

    function configureRoutes($stateProvider, $urlRouterProvider, $locationProvider) {
        if (window.wf__embeddedWidgetMode) return

        $urlRouterProvider.otherwise('/')
        $locationProvider.html5Mode({
            enabled: true,
        })

        $stateProvider
            .state('login', {
                url: '/login?redirect',
                controller: ['$scope', '$rootScope', 'wfAuth', 'responsiveUi', '$stateParams', function ($scope, $rootScope, wfAuth, responsiveUi, $stateParams) {
                    responsiveUi.enableResponsiveness()
                    responsiveUi.disableResponsivenessOnScopeDestroy($scope)

                    $rootScope.setPageTitle('Login')
                    $rootScope.$broadcast('auth0.logout')
                    localStorage.setItem('login_state', 'login')

                    localStorage.removeItem('redirectPathAfterLogin')

                    if ($stateParams.redirect) {
                        localStorage.setItem('redirectPathAfterLogin', $stateParams.redirect)
                    }

                    wfAuth.signIn()
                }],
            })
            .state('auth0-login-callback', {
                url: '/login-callback',
                template: '<div wf-if-first="showError"><div class="page-heading pt30 pb0">'
						+ '<h1>Could not sign in to Worldfavor</h1></div>'
						+ '</div><div style="font-size:16px;padding-bottom:30px">'
						+ '<p>An error occured during authentication. You can try to <a ng-href="{{::loginUrl}}">sign in again</a> or just go to the <a href="https://worldfavor.com">Worldfavor start page</a>.<br />To contact support, please reach out to <a href="mailto:support@worldfavor.com">support@worldfavor.com</a> and include the error information below.</p></div>'
						+ '<h3 style="border-top:1px solid #ccc;margin-top:0;padding-top:30px;margin-bottom:20px">Error information</h3>'
						+ '<div ng-bind="header" style="padding-bottom:5px;font-weight:700"></div><p style="font-size:12px;padding-bottom:20px" ng-bind="description"></p>'
						+ '</div>',
                controller: ['$scope', '$rootScope', 'wfAuth', 'responsiveUi', '$state', function ($scope, $rootScope, wfAuth, responsiveUi, $state) {
                    let hashObject; let errorDescription
                    responsiveUi.enableResponsiveness()
                    responsiveUi.disableResponsivenessOnScopeDestroy($scope)

                    if (typeof location.hash === 'string' && location.hash.length) {
                        hashObject = _.chain(location.hash.substr(1))
                            .split('&')
                            .map((el) => { return el.split('=') })
                            .fromPairs()
                            .mapValues((el) => { return decodeURIComponent(el) })
                            .value()

                        if (hashObject.error) {
                            $scope.showError = true
                            $scope.loginUrl = $state.href(localStorage.getItem('login_state') || 'login')

                            const { error, error_description } = hashObject

                            $scope.header = error
                            $scope.description = error_description

                            // if (hashObject.error === "unauthorized") {
                            // 	$scope.description = "Your are not authorized to sign in to Worldfavor."
                            // }
                            // else {
                            //
                            // }

                            if (!$scope.header && !$scope.description) {
                                $scope.header = 'Authentication Error'
                                $scope.description = JSON.stringify(hashObject)
                            }

                        }
                        else if (hashObject.access_token) {

                        }
                        else {
                            $state.go('root', null, { location: 'replace' })
                        }
                    }
                    else {
                        $state.go('root', null, { location: 'replace' })
                    }
                }],
            })
        // .state('signup', {
        // 	url: '/signup',
        // 	controller: [ '$scope', '$rootScope', 'DS', '$timeout', 'dataOperationsService', 'wfAuth', 'responsiveUi', function ($scope, $rootScope, DS, $timeout, dataOps, wfAuth, responsiveUi) {
        // 		initHubSpot();
        // 		responsiveUi.enableResponsiveness();
        // 		responsiveUi.disableResponsivenessOnScopeDestroy($scope);
        // 		$("body").addClass("signup");
        //
        // 		$rootScope.setPageTitle("Sign up");
        // 		wfAuth.signUp();
        //
        // 		$scope.$on("$destroy", function () {
        // 			$("body").removeClass("signup");
        // 		});
        // 	} ]
        // })
        // .state('signupClaimOrganization', {
        // 	url: "/signup/claimorganization",
        // 	templateUrl: 'scripts/wf/signup/wfClaimOrganization.controller.html'
        // })
        // .state('signupLandingPage', {
        // 	url: "/signup/landingpage",
        // 	template: '<wf-landing-page disable-adding-to-scope="true"></wf-landing-page>'
        // })
            .state('root', {
                url: '/',
                templateUrl(params) {
                    params.objectId = 10010
                    params.objectType = 71
                    params.childrenLoadDepth = 3
                    params.bypassCache = true
                    return 'scripts/wf/dashboard/rootStarter.controller.html'
                },
            })
            .state('dev', {
                url: '/dev-test',
                controller: 'DevTestingController',
                controllerAs: 'vm',
                templateUrl(params) {
                    return 'scripts/wf/_dev/devTesting.controller.html'
                },
            })
            .state('dev-org', {
                url: '/dev-org',
                template: '<div></div>',
                controller: ['valueChainService', function (valueChainService) {
                    valueChainService.createOrganization({ type: 52, id: 75 }, {})
                }],
            })
            .state('dev-analyze', {
                url: '/dev-analyze',
                template: '<div></div>',
                controller: ['analyzeService', function (analyzeService) {
                    // analyzeService.editRequirements();
                    // analyzeService.openAnalyzeJobCreator({ organization: { id: 4520, name: "Test AB org" }, networkId: 63 });
                    analyzeService.editRequirements({ type: 73, id: 1, childType: 11, childContent: { type: 11 } }, { organization: { id: 4520, name: 'Test AB org' }, networkId: 63 })
                }],
            })
            .state('dev-analyze2', {
                url: '/dev-analyze2',
                template: '<br /><br /><br /><panel style="width:900px"><div class="clearfix pt5 pb5"><div style="float:right;width:250px"><wf-analyze-requirements item="{ id: 2, type: 73, childId: 3, childType: 11, childContent: { type: 11 } }"></wf-analyze-requirements></div>'
				+ '</div><hr style="border-top-color: #ddd" />'
				+ '<div class="clearfix pt5 pb5"><div style="float:right;width:250px"><wf-analyze-requirements item="{ id: 1, type: 73, childId: 2, childType: 71, childContent: { type: 71, conditions: {'
					+ ' pickerSettings: {\'sourceItem\':\'71-13804\',\'openerButtonTranslate\':\'Select\'} } } }"></wf-analyze-requirements></div></div>'
				+ '</panel>',
                controller: ['analyzeService', function (analyzeService) {
                    // analyzeService.editRequirements();
                }],
            })
            .state('dev-analyze-editor', {
                url: '/analyze/package',
                template: '<wf-hierarchical>',
                controller: ['analyzeService', function (analyzeService) {
                    analyzeService.editRequirements()
                }],
            })
            .state('dev-measure-ranges', {
                url: '/dev-mes-range',
                template: '<div style=\'margin:auto;margin-top:100px;width:700px\'><panel><wf-measure-period-settings-editor value=\'{ frequency: 5, ranges: [] }\'></wf-measure-period-settings-editor></panel></div>',
                controller: [function () {
                    console.log('asdf')
                }],
            })
            .state('dev-consolidate', {
                url: '/dev-consolidate',
                templateUrl(params) {
                    return 'scripts/wf/_dev/dev_consolidate.controller.html'
                },
            })
            .state('dev-pdf', {
                url: '/dev-pdf',
                template: '<div>Generate and download PDF</div>',
                controller: ['pdfGenerator', function (pdfGenerator) {
                    const xhr = pdfGenerator.fromHtml('nice test', 'xxx' + '_' + moment().format('YYYY-MM-DD'), null, { onlyDownload: true })
                    // xhr.then(function (res) {

                    // });
                }],
            })
            .state('dev-mes', {
                url: '/dev-mes',
                template: '<div class=\'container-fluid\' style=\'margin-top:0\'><div class=\'btn btn-default\' style=\'margin-bottom:200px\' ng-click=\'vm.initAgain()\'>Init</div><div ng-if=\'vm.loaded\' class=\'row\'><div class=\'col-xs-2 measure-display-variant-wrapper\' ng-repeat=\'relation in ::vm.measureRelations\'><wf-measure-display-variant measure=\'relation.childContent\' measure-relation=\'relation\'></wf-measure-display-variant></div></div></div>',
                controllerAs: 'vm',
                controller: ['dataOperationsService', '$timeout', function (dataOps, $timeout) {
                    const vm = this
                    dataOps.getObject({
                        objectType: 71,
                        objectId: 17627,
                        childrenLoadDepth: 2,
                    }).then((res) => {
                        vm.measureRelations = _.filter(res.childs, (relation) => {
                            return relation.childContent.childs.length
                        })
                        vm.loaded = true
                        $timeout()
                    })

                    vm.initAgain = function () {
                        vm.loaded = false
                        $timeout(() => {
                            vm.loaded = true
                        }, 0)
                    }
                }],
            })
            .state('dev-agg', {
                url: '/dev-agg',
                template: '<wf-materiality-analysis></wf-materiality-analysis>',
            })
            .state('dev-findings', {
                url: '/dev-find-create',
                // template: '<wf-item ng-if="item" item="item" template-id="43" context="{ uiMode: uiMode }"></wf-item>',
                template: '<div></div>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', 'modalService', function ($scope, $stateParams, dataOps, modal) {
                    modal.createWithPromise({ type: enums.objectType.finding })
                }],
            })

            .state('scope-dashboard', {
                url: '/dashboard?source&view',
                params: {
                    hierarchyStructureId: 387,
                    categoryStructureId: 19238,
                },
                template: '<wf-manage-scope-dashboard hierarchy-structure-id="vm.hierarchyStructureId" category-structure-id="vm.categoryStructureId" source-network-id="vm.networkId"></wf-manage-scope-dashboard>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', function ($scope, $stateParams, dataOps) {
                    const vm = this

                    console.log($stateParams)

                    vm.networkId = $stateParams.source ? parseInt($stateParams.source) : undefined
                    vm.hierarchyStructureId = $stateParams.hierarchyStructureId
                    vm.categoryStructureId = $stateParams.categoryStructureId
                }],
            })

        // .state('public-profile', {
        // 	url: "/public-profile?view",
        // 	template: '<wf-manage-scope-dashboard hierarchy-structure-id="vm.hierarchyStructureId" category-structure-id="vm.categoryStructureId" config="vm.config" views-structure-id="vm.viewsStructureId"></wf-manage-scope-dashboard>',
        // 	controllerAs: "vm",
        // 	controller: [ "$scope", "$stateParams", "dataOperationsService", function ($scope, $stateParams, dataOps, enums) {
        // 		var vm = this;

        // 		vm.hierarchyStructureId = $stateParams.view ? parseInt($stateParams.view) : 19979;
        // 		vm.categoryStructureId = $stateParams.int === "0" ? undefined : enums.ids.scopeDashboard.publicScope;
        // 		vm.config = { showDataSourceSelector: false, showViewAdder: false };
        // 		vm.viewsStructureId = enums.ids.scopeDashboard.viewsForPublicScope;
        // 	}]
        // })

            .state('manageScopeDashboard-default', {
                url: '/manage-scope?' + [
                    'source', // Network ID
                    'view', // Hierarchy structure ID
                    'int', // Disable intersection with value of 0 or specify intersection/category structure with an id
                    'primaryItemDepth', // If hierarchy structure is missing primary item determinator then use this value
                    'multiLevels', // If truthy, multiple levels support is enabled
                    'uiMode',
                    'inf',
                ].join('&'),
                params: {
                    hierarchyStructureId: 10517,
                    categoryStructureId: 19238,
                },
                template: '<wf-manage-scope-dashboard'
					+ ' hierarchy-structure-id="vm.hierarchyStructureId"'
					+ ' category-structure-id="vm.categoryStructureId"'
					+ ' views-structure-id="vm.viewsStructureId"'
					+ ' source-network-id="vm.networkId"'
					+ ' influence-id="vm.influenceId"'
					+ ' config="vm.config"'
					+ '></wf-manage-scope-dashboard>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', 'dataQuery', function ($scope, $stateParams, dataOps, dataQuery) {
                    const vm = this

                    vm.hierarchyStructureId = $stateParams.hierarchyStructureId
                    vm.categoryStructureId = $stateParams.categoryStructureId

                    vm.networkId = $stateParams.source ? parseInt($stateParams.source) : undefined
                    vm.hierarchyStructureId = $stateParams.view ? parseInt($stateParams.view) : -1
                    vm.categoryStructureId = $stateParams.int === '0' ? undefined : ($stateParams.int || enums.ids.scopeDashboard.privateScope)
                    vm.viewsStructureId = 19644
                    vm.influenceId = $stateParams.inf
                    vm.config = {
                        primaryItemDepth: $stateParams.primaryItemDepth ? parseInt($stateParams.primaryItemDepth) : undefined,
                        uiMode: $stateParams.uiMode === 'work' ? enums.uiMode.work : undefined,
                        primaryItemDeterminator: $stateParams.multiLevels && function (itemComposite) {
                            if (itemComposite.type === enums.objectType.structure && !dataQuery.hasItemAnySettingForAttachingData(itemComposite)) {
                                return true
                            }
                        },
                    }
                }],
            })
            .state('manageScopeDashboard', {
                url: '/manage-scope/{hierarchyStructureId:int}',
                params: {
                    hierarchyStructureId: 387,
                    categoryStructureId: 19238,
                },
                template: '<wf-manage-scope-dashboard hierarchy-structure-id="vm.hierarchyStructureId" category-structure-id="vm.categoryStructureId"></wf-manage-scope-dashboard>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', function ($scope, $stateParams, dataOps) {
                    const vm = this

                    vm.hierarchyStructureId = $stateParams.hierarchyStructureId
                    vm.categoryStructureId = $stateParams.categoryStructureId
                }],
            })
            .state('manageScopeDashboard-dev', {
                url: '/dev-scope',
                template: '<h2 ng-bind-html="modalHeader"></h2><wf-easy-list config="vm.listConfig"></wf-easy-list>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', function ($scope, $stateParams, dataOps) {
                    const vm = this

                    /*
						16052 Targets from SDG
						19385 Disclosures from GRI Standards

						10517 GRI Standards
						387 SDG

						19238 Private scope

						Single Discloure with measures as Children
						Single Target with measures and LinkageChildren

						Requirements:
						- Extend the current scope with primary items
						- Extend a primary item with measures and attached info
						- Extend either the scope or a primary item with custom items/measures
					*/

                    // If adding to the scope (main list)
                    vm.listConfig = {
                        categoryStructureId: 19238,
                        // primaryItemType: enums.objectType.structure,
                        // enableSubItems: false,
                        // enableLinkage: false,
                        // enableLearnMore: false,
                        // sideAction: {
                        // 	tool: "toggle",
                        // 	relationTarget: { item: { type: 71, id: 19238, wfid: "71-19238" }, kind: enums.subItemsKind.childrenByUser }
                        // }
                    }

                    // If adding to a primary item
                    // vm.listConfig =  {
                    // 	categoryStructureId: itemComposite.id,
                    // 	categoryStructureConfig: {
                    // 		subItemsKind: categoryStructure_subItemsKind,
                    // 		loadDepth: 1
                    // 	},
                    // 	hierarchyStructureId: hierarchyStructureId,
                    // 	primaryItemType: enums.objectType.measure,
                    // 	sideAction: {
                    // 		tool: "toggle",
                    // 		relationTarget: { item: categoryStructure, kind: enums.subItemsKind.childrenByUser }
                    // 	}
                    // }
                }],
            })
            .state('dev-addorg', {
                url: '/dev-addorg',
                template: '<div><wf-value-chain-organization-adder organization="org" /></div>',
                controllerAs: 'vm',
                controller: ['$scope', '$stateParams', 'dataOperationsService', function ($scope, $stateParams, dataOps) {
                    $scope.org = {
                        id: 122012,
                        name: 'Worldfavor Development Supplier 50',
                        type: enums.objectType.organization,
                        wfid: '101-122012',
                    }
                }],
            })
            .state('transfer', {
                url: '/transfer-manager',
                controller: 'TransferController',
                controllerAs: 'vm',
                templateUrl(params) {
                    return 'scripts/wf/transferManager/transfer.controller.html'
                },
            })
            .state('intro', {
                url: '/intro',
                templateUrl(params) {
                    params.objectId = 10010
                    params.objectType = 71
                    params.childrenLoadDepth = 3
                    params.bypassCache = true
                    return 'scripts/wf/dashboard/rootStarter.controller.html'
                },
            })
            .state('dataRelation_noUrl', {
                //data: { requiresLogin: true },
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]
                    params.objectId = parseInt(objectId)
                    params.objectType = 73
                    //params.childrenLoadDepth = 1;

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('dataRelation', {
                //data: { requiresLogin: true },
                url: '/rel/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = _.filter(params.idPath.toString().split('/').reverse(), (item) => {
                        return item != ''
                    })
                    const objectId = path[0]

                    params.isSubObject = false
                    params.objectId = parseInt(objectId)
                    params.objectType = 73
                    // console.log("rel", params.idPath, params.objectId, params.subObjectId, params);
                    //params.childrenLoadDepth = 1;

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('hierarchy', {
                //data: { requiresLogin: true },
                url: '/hierarchy/{direction}/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]
                    params.objectId = parseInt(objectId)
                    params.objectType = 73
                    params.direction = params.direction === 'up' ? params.direction : 'down'
                    params.templateId = 32
                    params.hierarchy = true
                    //params.childrenLoadDepth = 1;

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('structure', {
                //data: { requiresLogin: true },
                url: '/struct/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]
                    params.objectId = parseInt(objectId)
                    params.objectType = 71
                    params.childrenLoadDepth = 1

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('veri', {
                //data: { requiresLogin: true },
                url: '/veri/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]
                    params.objectId = parseInt(objectId)
                    params.objectType = 67
                    params.childrenLoadDepth = 1

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('network', {
                //data: { requiresLogin: true },
                url: '/net/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]
                    params.objectId = parseInt(objectId)
                    params.objectType = 52
                    params.childrenLoadDepth = 1

                    params.get = function (dataOps) {
                        // objectType: 71,
                        // 		groupBy: {
                        // 			type: 52,
                        // 			id: params.objectId
                        // 		}

                        return dataOps.getObject({
                            objectType: params.objectType,
                            objectId: params.objectId,
                            childrenGetterConditions: {
                                objectType: 13, // Influence
                                networkId: params.objectId,
                            },
                            bypassCache: true,
                        })
                    }

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('influence', {
                //data: { requiresLogin: true },
                url: '/inf/{idPath}?{ui}',
                templateUrl(params) {
                    const path = params.idPath.toString().split('/').reverse()
                    const objectId = path[0]

                    if (objectId.indexOf('-') !== -1) {
                        params.lookupObjectWfid = objectId
                    }
                    else {
                        params.objectId = parseInt(objectId)
                        params.objectType = 13
                    }

                    params.childrenLoadDepth = 1

                    // params.get = function (dataOps) {
                    // 	return dataOps.getObject({
                    // 		objectType: params.objectType,
                    // 		objectId: params.objectId,
                    // 		// loadChildren: true,
                    // 		// loadRelatedContent: true,
                    // 		// loadRelatedContentByUser: true,
                    // 		// loadVerifications: true,
                    // 		// loadVerifies: true,
                    // 		bypassCache: true
                    // 	});
                    // };

                    return 'scripts/wf/influence/influence.controller.html'
                    // return 'scripts/wf/common/page.controller.html';
                },
                //controller:'PageController'
            })
            .state('public-influence', {
                url: '/inf/public/{influenceId:int}',
                template: '<wf-influence-viewer public-layout influence-id=\'influenceId\'></wf-influence-viewer>',
                controller: ['$scope', '$rootScope', '$stateParams', 'wfAuth', '$translate', 'responsiveUi', function($scope, $rootScope, $stateParams, wfAuth, $translate, responsiveUi) {
                    const
                        currentBrowser = $.browser

                    if ($.browser.msie) {
                        if (currentBrowser.versionNumber <= 11) {
                            $(document.body).addClass('browser-ie')
                            $rootScope.applyBrowserIEStyles = true
                        }
                    }

                    if (wfAuth.isAuthenticated()) {
                        $rootScope.usePublicLayout = true
                        $rootScope.setPublicLayoutClass()
                        responsiveUi.enableResponsiveness()
                        responsiveUi.disableResponsivenessOnScopeDestroy($scope)
                    }
                    else {
                        wfAuth.setAuthenticationHeaderValue('public')

                        $(document.body).addClass('dark')
                        $rootScope.useDarkModePublicLayout = true
                        $rootScope.setPublicLayoutClass()
                        // wfAuth.setAuthenticationHeaderValue("public-influence|" + res.id);
                    }

                    $translate.use('en-US')
                    moment.locale('en')
                    numeral.locale('en')

                    $scope.influenceId = $stateParams.influenceId
                    $scope.$on('$destroy', () => {
                        wfAuth.resetAuthenticationHeaderValue()
                        // $rootScope.usePublicLayout = false;
                        // $rootScope.useDarkModePublicLayout = false;

                        // reloading when the user clicks on any other route,
                        // the browser will properly fetch the non-responsive rules for any device (when inside Wf)
                        location.reload()

                    })
                }],
            })
            .state('insights', {
                url: '/insights',
                templateUrl(params) {
                    params.objectId = 18568
                    params.objectType = 71

                    return 'scripts/wf/common/page.controller.html'
                },
                controller: ['$scope', 'wfAuth', '$translate', function ($scope, wfAuth, $translate) {
                    wfAuth.forceCulture('en-US', false)

                    $scope.$on('$destroy', () => {
                        wfAuth.resetForcedCulture()
                    })
                }],
            })
            .state('vis-hier', {
                url: '/hier/vis/{objectWfid}',
                template: '<div ng-if="vm.loaded"><wf-hierarchical related-content-as-children friendly-titles item="vm.childContent" show-numbering="false"></wf-hierarchical></div>',
                controllerAs: 'vm',
                controller: ['$scope', '$rootScope', '$stateParams', 'wfAuth', 'dataOperationsService', 'dataQuery', '$timeout', function($scope, $rootScope, $stateParams, wfAuth, dataOps, dataQuery, $timeout) {
                    const
                        vm = this

                    const objectIdParts = $stateParams.objectWfid.split('-')

                    let objectType

                    let objectId

                    if (objectIdParts.length === 2) {
                        objectType = parseInt(objectIdParts[0])
                        objectId = parseInt(objectIdParts[1])
                    }

                    dataOps.getObject({
                        objectId,
                        objectType,
                        childrenLoadDepth: 10,
                        // readFromCache: true,
                        getterConditions: {
                            contextVariable1: 'onlyLatestAnswers',
                            applyIntersectionIfPossible: true,
                        },
                    }).then((res) => {
                        const flatItems = dataQuery.getHierarchyAsList(res)
                        vm.childContent = res

                        dataOps.getSubItemsOfAll(flatItems, enums.subItemsKind.relatedContentByUser, { bypassCache: true }).then(() => {
                            vm.loaded = true
                            $timeout()
                        })
                    })

                }],
            })
            .state('promotion', {
                url: '/promo?objectId&nameRef',
                templateUrl(params) {
                    return 'scripts/wf/promotion/promotion.controller.html'
                },
            })
            .state('objectViewer', {
                //data: { requiresLogin: true },
                url: '/obj/r/{objectWfid}',
                templateUrl: 'scripts/wf/objectViewer/objectViewer.controller.html',
                //controller:'ObjectViewerController'
            })
            .state('objectViewer_encoded', {
                //data: { requiresLogin: true },
                url: '/obj/{encodedData}?network',
                templateUrl(params) {
                    let output = atob(params.encodedData)

                    if (output.indexOf('{"') === 0) { // Stringified json variant
                        output = JSON.parse(output)
                        params.objectWfid = output.o
                        params.relationWfid = output.r
                        params.originalRelationWfid = output.or
                        params.positionRelationWfid = output.pr
                    }
                    else params.objectWfid = atob(output) // Double encoded wfid variant

                    return 'scripts/wf/objectViewer/objectViewer.controller.html'
                },
                //controller:'ObjectViewerController'
            })
            .state('dashboard', {
                //data: { requiresLogin: true },
                url: '/account/dashboard',
                templateUrl: 'scripts/wf/dashboard/dashboard.controller.html',
                controller: 'DashboardController',
            })
            .state('internalReport', {
                //data: { requiresLogin: true },
                url: '/report/internal',
                templateUrl: 'scripts/wf/report/internalReport.controller.html',
            })
            .state('report', {
                //data: { requiresLogin: true },
                url: '/report',
                // templateUrl: 'scripts/wf/report/report.controller.html',
                controller: ['$state', function ($state) {
                    $state.go('networkLandingScene', null, { location: 'replace' })
                }],
            })
            .state('transparency.requests', {
                //data: { requiresLogin: true },
                url: '/exchanges',
                // templateUrl: 'scripts/wf/report/report.controller.html'
                controller: ['$state', function ($state) {
                    $state.go('networkLandingScene', null, { location: 'replace' })
                }],
            })
            .state('accountSettings', {
                //data: { requiresLogin: true },
                url: '/account/settings',
                templateUrl: 'scripts/wf/settings/userSettings.controller.html',
                controller: 'WfUserSettingsController',
            })
            .state('accountUpgrade', {
                //data: { requiresLogin: true },
                url: '/account/upgrade',
                templateUrl: 'scripts/wf/subscription/upgrade.controller.html',
            })
            .state('organizationUsers', {
                //data: { requiresLogin: true },
                url: '/organization/users',
                templateUrl: 'scripts/wf/users/users.controller.html',
                // controller:'UsersController'
            })
            .state('organizationSettings', {
                //data: { requiresLogin: true },
                url: '/organization/settings',
                templateUrl: 'scripts/wf/settings/orgSettings.controller.html',
            })
            .state('organizationPanel', {
                url: '/account',
                templateUrl: 'scripts/wf/settings/orgPanel.controller.html',
                controller: 'WfOrganizationPanelController',
                controllerAs: 'vm',
            })
            .state('orgPanel/account/organization/settings', {
                parent: 'organizationPanel',
                url: '/organization/settings',
                templateUrl: 'scripts/wf/settings/orgSettings.controller.html',
            })
            .state('orgPanel/account/organization/data-explorer', {
                parent: 'organizationPanel',
                url: '/organization/data-explorer',
                templateUrl: 'scripts/wf/settings/dataExplorer.controller.html',
            })
            .state('orgPanel/account/organization/third-party-permissions', {
                parent: 'organizationPanel',
                url: '/organization/third-party-permissions',
                templateUrl: 'scripts/wf/settings/thirdPartyPermissions.controller.html',
            })
            .state('orgPanel/account/organization/users', {
                parent: 'organizationPanel',
                url: '/organization/users',
                templateUrl: 'scripts/wf/users/users.controller.html',
            })
            .state('orgPanel/account/organization/events', {
                parent: 'organizationPanel',
                url: '/organization/events',
                templateUrl(params) {
                    params.objectId = 11723
                    params.objectType = 71

                    return 'scripts/wf/account/eventLog.controller.html'
                },
                controller: 'EventLogController',
            })
            .state('orgPanel/account/dataRelation', {
                parent: 'organizationPanel',
                url: '/rel/{idPath:[0-9/]*}',
                templateUrl(params) {
                    const path = _.filter(params.idPath.toString().split('/').reverse(), (item) => {
                        return item != ''
                    })
                    const objectId = path[0]

                    params.isSubObject = false
                    params.objectId = parseInt(objectId)
                    params.objectType = 73

                    return 'scripts/wf/common/page.controller.html'
                },
            })
            .state('accountNotifications', { // Notifiations with the current user as recipient (Notifications table)
                //data: { requiresLogin: true },
                url: '/account/log',
                templateUrl(params) {
                    params.objectId = 11648
                    params.objectType = 71

                    return 'scripts/wf/account/eventLog.controller.html'
                },
                controller: 'EventLogController',
            })
            .state('organizationEventLog', { // Events for the current organization (LogEvents table)
                //data: { requiresLogin: true },
                url: '/organization/events',
                templateUrl(params) {
                    params.objectId = 11723
                    params.objectType = 71

                    return 'scripts/wf/account/eventLog.controller.html'
                },
                controller: 'EventLogController',
            })
            .state('userInbox', {
                //data: { requiresLogin: true },
                url: '/account/inbox',
                templateUrl(params) {
                    params.objectWfid = '100-' + currentWorldfavorUserId

                    return 'scripts/wf/objectViewer/objectViewer.controller.html'
                },
            })
            .state('accountOrganizations', {
                //data: { requiresLogin: true },
                url: '/account/organizations',
                templateUrl(params) {
                    params.objectId = 43051
                    params.objectType = 73
                    params.skipExtras = true

                    return 'scripts/wf/common/page.controller.html'
                },
                //controller:'PageController'
            })
            .state('temp', {
                url: '/temp',
                template: '<div class=\'btn btn-primary mt40\' wf-click=\'preview()\'>Open modal</div>',
                controller: ['$scope', 'modalService', 'apiProxy', function ($scope, modal, apiProxy) {

                    $scope.preview = function () {
                        modal.previewMail({ userIds: [3], networkId: 44, mailPurpose: 2, organizationId: 120136, showSendButton: true, showForm: true, onSent() { console.log('Sent!') } })
                    }

                    $scope.preview()
                }],
            })
            .state('public', {
                url: '/public/{roomRouteName}',
                templateUrl(params) {
                    return 'scripts/wf/publicInfluences/publicInfluences.controller.html'
                },
                controllerAs: 'vm',
                controller: 'PublicInfluencesController',
            })
            .state('standards', {
                url: '/standards',
                templateUrl: 'scripts/wf/standards/standards.controller.html',
            })
            .state('manage', {
                url: '/manage',
                templateUrl: 'scripts/wf/manage/manage.controller.html',
                controllerAs: 'vm',
            })
            .state('manage.child', {
                url: '/{subObjectId}',
                templateUrl(params) {
                    params.objectId = parseInt(params.subObjectId)
                    params.objectType = 73
                    params.hideBackButton = true

                    return 'scripts/wf/common/page.controller.html'
                },
            })
            .state('dataRelation.child', {
                url: '/data/{subObjectId}',
                parent: 'dataRelation',
                templateUrl(params) {
                    params.objectId = parseInt(params.idPath)
                    params.subObjectId = parseInt(params.subObjectId)
                    params.isSubObject = true
                    params.objectType = 73
                    params.hideBackButton = true
                    // console.log("child", params.objectId, params.subObjectId, params);

                    return 'scripts/wf/common/page.controller.html'
                },
                //  resolve: {
                // 	delayer: ['$timeout', function ($timeout) {
                // 		console.log("delay start")
                // 		return $timeout(function () {
                // 			console.log("delay done")
                // 		}, 1000);
                // 	}],
                // }
            })
            .state('room-admin', {
                url: '/room-admin/{roomId}',
                templateUrl(params) {
                    params.roomId = parseInt(params.roomId)
                    params.isAdminMode = true

                    return 'scripts/wf/sustainabilityRoom/sustainabilityRoom.controller.html'
                },
                controllerAs: 'vm',
                controller: 'SustainabilityRoomController',
            })
            .state('room-admin.child', {
                url: '/item/{objectId}',
                templateUrl(params) {
                    params.objectId = parseInt(params.objectId)
                    params.objectType = 73
                    params.networkId = 1
                    params.isViewMode = true
                    params.templateIdFallback = 75
                    params.ticket = {
                        networkId: 1,
                    }
                    params.hideBackButton = true

                    return 'scripts/wf/common/page.controller.html'
                },
            })
            .state('room', {
                url: '/room/{roomRouteName}',
                templateUrl(params) {
                    params.roomRouteName = params.roomRouteName
                    // params.objectId = params.roomId

                    return 'scripts/wf/sustainabilityRoom/sustainabilityRoom.controller.html'
                },
                controllerAs: 'vm',
                controller: 'SustainabilityRoomController',
            })
            .state('room.child', {
                url: '/item/{objectId}',
                templateUrl(params) {
                    params.objectId = parseInt(params.objectId)
                    params.objectType = 73
                    params.networkId = 1
                    params.isViewMode = true
                    params.templateIdFallback = 75
                    params.ticket = {
                        networkId: 1,
                    }
                    params.hideBackButton = true

                    return 'scripts/wf/common/page.controller.html'
                },
            })
            .state('isoStandards', {
                url: '/isostandards',
                templateUrl: 'scripts/wf/isoStandards/isoStandards.controller.html',
            })
            .state('visualize', {
                url: '/visualize',
                templateUrl(params) {
                    // console.log("templateUrl", wfObject.get("71-10010"));
                    // if (nice) {
                    params.nameRef = 'Visualize'
                    return 'scripts/wf/promotion/promotion.controller.html'
                    // }
                    // else{
                    // 	params.isSubObject = false;
                    // 	params.objectId = parseInt(objectId);
                    // 	params.objectType = 73;
                    // 	return 'scripts/wf/common/page.controller.html';
                    // }

                },
                // resolve: {
                // 	rootObjectPromise: function () {
                // 		return $q(function (resolve, reject) {
                // 			dataOps.getObject("71-10010", {
                // 				objectId: 10010,
                // 				objectType: 71,
                // 				childrenLoadDepth: 3
                // 			}).then(function () {
                // 				resolve();
                // 			});
                // 		});
                // 	}
                // }
            })
            .state('internalValueChain', {
                url: '/valuechain/internal',
                templateUrl(params) {
                    return 'scripts/wf/valueChain/internalValueChainUsers.controller.html'
                },
                // controllerAs: "vm",
                // controller:'ValueChainController'
            })
            .state('internalValueChainMailSettings', {
                url: '/valuechain/internal/mailsettings',
                templateUrl(params) {
                    params.isInternalValueChain = true
                    return 'scripts/wf/valueChain/valueChainMailSettings.controller.html'
                },
                // controllerAs: "vm",
                // controller:'ValueChainController'
            })
            .state('analyzePackages', {
                url: '/analyze',
                templateUrl: 'scripts/wf/analyze/analyzePackages.controller.html',
            })
            .state('analyzeJob', {
                url: '/analyze/jobs/{jobId:int}',
                template: '<wf-analyze-job job-id="jobId"></wf-analyze-job>',
                controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
                    $scope.jobId = $stateParams.jobId
                }],
            })
            .state('analyzePackageEditor', {
                url: '/analyze/packages/{objectId:int}',
                templateUrl: 'scripts/wf/analyze/editor/analyzePackageEditor.template.html',
                controller: ['$scope', '$stateParams', function ($scope, $stateParams) {
                    $scope.structureId = $stateParams.objectId
                }],
            })
            .state('widget', {
                url: '/widget/{objectId}',
                templateUrl(params) {
                    params.objectId = parseInt(params.objectId)
                    params.isAdminMode = true

                    return 'scripts/wf/widget/widget.controller.html'
                },
                // controllerAs: "vm",
                // controller:'WidgetController'
            })
            .state('widgets', {
                url: '/visualize/widgets',
                templateUrl(params) {
                    params.objectId = parseInt(params.objectId)
                    return 'scripts/wf/widget/widgets.controller.html'
                },
            })
            .state('hier', {
                url: '/hier/{objectId:string}?jump&intersect&ignoreDepthLimits',
                templateUrl(params) {
                    // params.objectId = 10010;
                    // params.objectType = 73;
                    // params.childrenLoadDepth = 3;
                    // params.bypassCache = true;

                    return 'scripts/wf/hierarchical/hierarchical.controller.html'
                },
                // controller:'PageController'
            })
            .state('hier-public', {
                url: '/hier/public/{objectId:string}?jump&intersect',
                templateUrl(params) {
                    // params.objectId = 10010;
                    // params.objectType = 73;
                    // params.childrenLoadDepth = 3;
                    params.ignoreAdditionalLoadDepthLimits = true
                    params.hierarchyFilter = 1
                    params.includeRelatedContentAsChildren = true

                    return 'scripts/wf/hierarchical/hierarchicalPublicLayout.controller.html'
                },
                // controller:'PageController'
            })
            .state('hierEditor', {
                url: '/hier/editor/{objectId:string}',
                templateUrl(params) {
                    // params.objectId = 10010;
                    // params.objectType = 73;
                    // params.childrenLoadDepth = 3;
                    // params.bypassCache = true;

                    return 'scripts/wf/hierarchical/hierarchicalEditor.controller.html'
                },
                // controller:'PageController'
            })
            .state('list', {
                url: '/list/{objectWfid:string}?depth',
                template(params) {
                    return '<wf-list-interface show-loaded-item from-item="{ wfid: \'' + params.objectWfid + '\' }" depth=' + params.depth + '></wf-list-interface>'
                },
                // controller:'PageController'
            })
            .state('list-sandbox', {
                url: '/list-sandbox',
                template(params) {
                    return '<wf-list-interface-sandbox></wf-list-interface-sandbox>'
                },
                // controller:'PageController'
            })
            .state('pick', {
                url: '/pick',
                templateUrl: 'scripts/wf/picker/picker.controller.html',
            })
            .state('login-link', {
                url: '/login-link',
                controller: ['auth', 'store', '$scope', '$rootScope', 'DS', 'dataOperationsService', function (auth, store, $scope, $rootScope, DS, dataOps) {
                    auth.signout() // Sign out with Auth0

                    // Clear all data in storage (angular-storage, used by Auth0)
                    store.remove('profile')
                    store.remove('token')

                    DS.clear() // Clear all cached data in JSData
                    dataOps.clearCachedRequests()
                    $rootScope.isLoggedIn = false // Set to false so that UI updates

                    // Initialize Passwordless Lock instance
                    const lock = new Auth0LockPasswordless('OfxP4kGpndPic3A6veHNy6JYGQQdD1Py', 'worldfavor.eu.auth0.com')
                    // Open the lock in Email Magic Link mode
                    lock.magiclink()
                }],
            })
            .state('login-sms', {
                url: '/login-sms',
                controller: ['auth', 'store', '$scope', '$rootScope', 'DS', '$timeout', '$state', 'dataOperationsService', function (auth, store, $scope, $rootScope, DS, $timeout, $state, dataOps) {
                    auth.signout() // Sign out with Auth0

                    // Clear all data in storage (angular-storage, used by Auth0)
                    store.remove('profile')
                    store.remove('token')

                    DS.clear() // Clear all cached data in JSData
                    dataOps.clearCachedRequests()
                    $rootScope.isLoggedIn = false // Set to false so that UI updates

                    // Initialize Passwordless Lock instance
                    const lock = new Auth0LockPasswordless('OfxP4kGpndPic3A6veHNy6JYGQQdD1Py', 'worldfavor.eu.auth0.com')
                    // Open the lock in Email Code mode with the ability to handle
                    // the authentication in page
                    const appearanceOpts = {
                        autoclose: true,
                        disableSignupAction: true,
                    }
                    // Open the lock in SMS mode with the ability to handle the authentication in page
                    lock.sms(appearanceOpts, (error, profile, id_token, access_token, state, refresh_token) => {
                        if (!error) {
                            // Save the JWT token.
                            store.set('token', id_token)
                            store.set('profile', profile)
                            $timeout(() => {
                                // console.log("go to org page");
                                $rootScope.isLoggedIn = true
                                auth.authenticate(profile, id_token)
                                $state.go('accountOrganizations')
                            }, 500)
                        }
                    })
                }],
            })
            .state('login-code', {
                url: '/login-code',
                controller: ['auth', 'store', '$scope', '$rootScope', 'DS', '$timeout', '$state', 'dataOperationsService', function (auth, store, $scope, $rootScope, DS, $timeout, $state, dataOps) {
                    auth.signout() // Sign out with Auth0

                    // Clear all data in storage (angular-storage, used by Auth0)
                    store.remove('profile')
                    store.remove('token')

                    DS.clear() // Clear all cached data in JSData
                    dataOps.clearCachedRequests()
                    $rootScope.isLoggedIn = false // Set to false so that UI updates

                    // Initialize Passwordless Lock instance
                    const lock = new Auth0LockPasswordless('OfxP4kGpndPic3A6veHNy6JYGQQdD1Py', 'worldfavor.eu.auth0.com')

                    const appearanceOpts = {
                        autoclose: true,
                    }

                    // Open the lock in Email Code mode with the ability to handle
                    // the authentication in page
                    lock.emailcode(appearanceOpts, (err, profile, id_token, state) => {
                        if (!err) {
                            // Save the JWT token.
                            store.set('token', id_token)
                            store.set('profile', profile)
                            $timeout(() => {
                                // console.log("go to org page");
                                $rootScope.isLoggedIn = true
                                auth.authenticate(profile, id_token)
                                $state.go('accountOrganizations')
                            }, 500)
                        }
                    })
                }],
            })
            .state('account-activateUser', {
                url: '/account/activate/{userToken}',
                templateUrl() {
                    return 'scripts/wf/authentication/setPassword.controller.html'
                },
            })
            .state('iso14001-text', {
                url: '/standards/iso14001/texts',
                templateUrl: 'scripts/wf/temp/iso14001_texts.controller.html',
                controllerAs: 'vm',
            })
            .state('iso9001-text', {
                url: '/standards/iso9001/texts',
                templateUrl: 'scripts/wf/temp/iso9001_texts.controller.html',
                controllerAs: 'vm',
            })
            .state('admin-accounts', {
                url: '/admin/accounts',
                templateUrl: 'scripts/wf/admin/accounts.controller.html',
            })
            .state('admin-xml-importer', {
                url: '/admin/xml-importer',
                templateUrl: 'scripts/wf/xmlImporter/xmlImporter.template.html',
            })
            .state('admin-valueChainImporter', {
                url: '/admin/valuechain-importer',
                templateUrl: 'scripts/wf/importExport/wfValueChainImporter.template.html',
            })
            .state('admin-orgAccessTags', {
                url: '/admin/org-access?{orgId:int}&{userId:int}',
                templateUrl(params) {
                    params.objectId = '71-13544'
                    params.orgAccessAdmin = true
                    // params.objectType = 73;
                    // params.childrenLoadDepth = 3;
                    // params.bypassCache = true;

                    return 'scripts/wf/hierarchical/hierarchical.controller.html'
                },
            })
            .state('admin-mailSettings', {
                url: '/admin/mail-settings',
                templateUrl(params) {
                    params.objectId = '71-13544'
                    params.orgAccessAdmin = true

                    return 'scripts/wf/valueChain/valueChainMailSettings.controller.html'
                },
            })
            .state('sust-diagnosis', {
                url: '/sustainabilty-diagnosis',
                templateUrl(params) {
                    return 'scripts/wf/sustainabilityDiagnosis/sustainabilityDiagnosis.controller.html'
                },
            })
            .state('file-download', {
                url: '/file?{_:string}',
                controller: ['$scope', 'dataOperationsService', '$stateParams', function (scope, dataOps, $stateParams) {
                    scope.filename = $stateParams._
                }],
                template: '<wf-file-viewer filename="filename"></wf-file-viewer>'
            })

        //.state('account', {
        //		//data: { requiresLogin: true },
        //		url: "/account/organizations",
        //		templateUrl: function(params) {
        //			params.objectId = 43051;
        //			params.objectType = 73;

        //			return 'scripts/wf/common/page.controller.html';
        //		}
        //		//controller:'PageController'
        //});

        init()

        function init() {
            const
                valueChainRouteObjects = getValueChainRoutes()

            _.each(valueChainRouteObjects, (obj, key) => {
                $stateProvider.state(key, obj)
            })

            configPackageSolutionRoutes(valueChainRouteObjects)

            configEnterpriseLogins()
        }

        function getValueChainRoutes() {
            let output

            output = {
                'valueChain-root': {
                    url: '/valuechain',
                    templateUrl: 'scripts/wf/valueChain/valueChain.controller.html',
                },
                'valueChainOrganizations-overview': {
                    url: '/valuechain/{networkId:int}',
                    templateUrl: 'scripts/wf/valueChain/valueChainOrganizations.controller.html',
                },
                valueChainOrganizations: {
                    url: '/valuechain/{networkId:int}/categories/{parentId:int}',
                    templateUrl: 'scripts/wf/valueChain/valueChainOrganizations.controller.html',
                },
                valueChainPackages: {
                    url: '/valuechain/{networkId:int}/packages',
                    templateUrl: 'scripts/wf/valueChain/valueChainPackages.controller.html',
                },
                valueChainPackageEditor: {
                    url: '/valuechain/{networkId:int}/packages/{objectId:int}',
                    templateUrl: 'scripts/wf/valueChain/valueChainPackageEditor.controller.html',
                    params: { pushToHistory: true },
                },
                valueChainInternalPackages: { // The controller valueChainPackages checks if the route name contain "valueChainInternalPackages" to determine which structure id should be used
                    url: '/valuechain/{networkId:int}/internal-packages',
                    templateUrl: 'scripts/wf/valueChain/valueChainPackages.controller.html',
                },
                valueChainInternalPackageEditor: {
                    url: '/valuechain/{networkId:int}/internal-packages/{objectId:int}',
                    templateUrl: 'scripts/wf/valueChain/valueChainPackageEditor.controller.html',
                },
                valueChainPackageAggregation: {
                    url: '/valuechain/{networkId:int}/packages/{objectId:int}/consolidate',
                    templateUrl: 'scripts/wf/valueChain/valueChainPackageConsolidation.controller.html',
                },
                valueChainCategories: {
                    url: '/valuechain/{networkId:int}/categories',
                    templateUrl: 'scripts/wf/valueChain/valueChainCategories.controller.html',
                },
                valueChainMailSettings: {
                    url: '/valuechain/{networkId:int}/email/settings',
                    templateUrl: 'scripts/wf/valueChain/valueChainMailSettings.controller.html',
                },
                valueChainMailSettings_TEMP: { // Remove when db is updated with correct route
                    url: '/valuechain/{networkId:int}/mailsettings',
                    templateUrl: 'scripts/wf/valueChain/valueChainMailSettings.controller.html',
                },
                valueChainInflunceGrouper: {
                    url: '/valuechain/{networkId:int}/grouper/{structureId:int}',
                    templateUrl: 'scripts/wf/influence/influenceGrouper.controller.html',
                },
                valueChainAnalyzePackages: {
                    url: '/valuechain/{networkId:int}/analyze-packages',
                    templateUrl: 'scripts/wf/analyze/package/valueChainAnalyzePackages.controller.html',
                },
                valueChainAnalyzePackageEditor: {
                    url: '/valuechain/{networkId:int}/analyze-packages/{objectId:int}',
                    templateUrl: 'scripts/wf/analyze/package/valueChainAnalyzePackageEditor.controller.html',
                    params: { pushToHistory: true },
                },
                valueChainNotifications: {
                    url: '/valuechain/{networkId:int}/notifications',
                    templateUrl(params) {
                        params.isNotifications = true
                        return 'scripts/wf/account/eventLog.controller.html'
                    },
                },
                valueChainMailHistory: {
                    url: '/valuechain/{networkId:int}/email/history',
                    templateUrl: 'scripts/wf/mail/mailHistory.controller.html',
                    controller: 'MailHistoryController',
                    controllerAs: 'mhVm',
                },
                valueChainAutomation: {
                    // The param networkId is used in wfPropertyExtractor to extract the networkId from the current state
                    // when constructing some urls with its itemNavigationLookup object.
                    url: '/valuechain/{networkId:int}/automation',
                    templateUrl: 'scripts/wf/common/page.controller.html',
                    controller: ['valueChainService', '$stateParams', function (valueChainService, $stateParams) {
                        $stateParams.objectType = enums.objectType.structure
                        $stateParams.objectId = valueChainService.ids.automationStructure
                    }],
                },
            }

            return output
        }

        function configPackageSolutionRoutes(valueChainRouteObjects) {
            const
                abstractParentRoutes = [
                    {
                        name: 'transparency',
                        url: '/transparency',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.transparency',
                            insights: {
                                scopeCategoryStructureId: 'ids.scopeDashboard.publicScope', // In enums. Same as dashboard.categoryStructureId
                            },
                            dashboard: [
                                {
                                    url: '/public-profile',
                                    config: { showDataSourceSelector: false, showViewAdder: false },
                                    hierarchyStructureId: 19979, // Public Profile structure
                                    categoryStructureId: 'ids.scopeDashboard.publicScope', // In enums. Same as insights.scopeCategoryStructureId
                                    viewsStructureId: 'ids.scopeDashboard.viewsForPublicScope', // In enums
                                },
                                {
                                    url: '/sust-information',
                                    config: { showDataSourceSelector: false, showViewAdder: false },
                                    categoryStructureId: 'ids.scopeDashboard.privateScope', // In enums. Same as insights.scopeCategoryStructureId
                                    viewsStructureId: 'ids.scopeDashboard.viewsForPrivateScope', // In enums
                                },
                            ],
                        },
                    },
                    {
                        name: 'sust-management',
                        url: '/sust-management',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustManagement',
                            networksStructureId: 'ids.networksStructureBySolution.sustManagement',
                            insights: {
                                scopeCategoryStructureId: 'ids.scopeDashboard.privateScope', // In enums. Same as dashboard.categoryStructureId
                            },
                            dashboard: {
                                config: { showDataSourceSelector: true, preselectedSource: 'ownData' },
                                permissionsStructureId: 'ids.scopeDashboard.privatePermissions', // In enums. Same as insights.scopeCategoryStructureId
                                categoryStructureId: 'ids.scopeDashboard.privateScope', // In enums. Same as insights.scopeCategoryStructureId
                                viewsStructureId: 'ids.scopeDashboard.viewsForPrivateScope', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustManagement', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-sourcing1',
                        url: '/sust-sourcing1',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustSourcing',
                            networksStructureId: 'ids.networksStructureBySolution.sustSourcing',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustSourcingPermissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustSourcingScope', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustSourcingScope', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustSourcing', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-sourcing2',
                        url: '/sust-sourcing2',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustSourcing2',
                            networksStructureId: 'ids.networksStructureBySolution.sustSourcing2',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustSourcing2Permissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustSourcingScope2', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustSourcingScope2', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustSourcing2', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-sourcing3',
                        url: '/sust-sourcing3',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustSourcing3',
                            networksStructureId: 'ids.networksStructureBySolution.sustSourcing3',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustSourcing3Permissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustSourcingScope3', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustSourcingScope3', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustSourcing3', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-sourcing4',
                        url: '/sust-sourcing4',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustSourcing4',
                            networksStructureId: 'ids.networksStructureBySolution.sustSourcing4',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustSourcing4Permissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustSourcingScope4', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustSourcingScope4', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustSourcing4', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-sourcing5',
                        url: '/sust-sourcing5',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustSourcing5',
                            networksStructureId: 'ids.networksStructureBySolution.sustSourcing5',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustSourcing5Permissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustSourcingScope5', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustSourcingScope5', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustSourcing5', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-lending',
                        url: '/sust-lending',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustLending',
                            networksStructureId: 'ids.networksStructureBySolution.sustLending',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                categoryStructureId: 'ids.scopeDashboard.sustLendingScope', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustLendingScope', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustLending', // In valueChainService
                            },
                        },
                    },
                    {
                        name: 'sust-investments',
                        url: '/sust-investments',
                        data: {
                            isSolutionRoot: true,
                            rootStructureId: 'ids.root.sustInvestments',
                            networksStructureId: 'ids.networksStructureBySolution.sustInvestments',
                            dashboard: {
                                config: { showDataSourceSelector: true },
                                permissionsStructureId: 'ids.scopeDashboard.sustInvestmentsPermissions', // In enums
                                categoryStructureId: 'ids.scopeDashboard.sustInvestmentsScope', // In enums
                                viewsStructureId: 'ids.scopeDashboard.viewsForSustInvestmentsScope', // In enums
                                sourcesStructureId: 'ids.networksStructureBySolution.sustInvestments', // In valueChainService
                            },
                        },
                    },
                ]

            _.each(abstractParentRoutes, (parentObj) => {
                const parentName = parentObj.name

                // This state is used as the root page for every package solution and most be registered first
                $stateProvider.state(parentName + '-root', {
                    url: parentObj.url,
                    templateUrl: 'scripts/wf/common/packageSolutionPage.controller.html',
                    controller: ['$stateParams', function ($stateParams) {
                        $stateParams.objectType = enums.objectType.structure
                        $stateParams.objectId = getValue(parentObj.data.rootStructureId, enums)
                    }],
                })

                // And this abstract state is used as the parent for all child states that will
                // have their url's prepended with the parent state url
                $stateProvider.state(_.assign(parentObj, {
                    abstract: true,
                    template: '<ui-view />',
                }))

                // Loop through valueChainRouteObjects add register states per solution
                _.each(_.cloneDeep(valueChainRouteObjects), (childObj, childName) => {
                    if (childName === 'valueChain-root' && parentObj.data.networksStructureId) {
                        childObj.controller = ['valueChainService', '$stateParams', function (valueChainService, $stateParams) {
                            $stateParams.networksStructureId = getValue(parentObj.data.networksStructureId, valueChainService)
                        }]
                    }

                    $stateProvider.state(parentName + '.' + childName, childObj)
                })

                if (parentObj.data.insights) {
                    $stateProvider.state(parentName + '.insights', {
                        url: '/insights',
                        templateUrl: 'scripts/wf/common/page.controller.html',
                        controller: ['$stateParams', function ($stateParams) {
                            $stateParams.objectId = 18568
                            $stateParams.objectType = 71
                            $stateParams.scopeCategoryStructureId = getValue(parentObj.data.insights.scopeCategoryStructureId, enums)
                            console.log($stateParams)

                            // wfAuth.forceCulture("en-US", false);

                            // $scope.$on("$destroy", function () {
                            // 	wfAuth.resetForcedCulture();
                            // });
                        }],
                    })
                }

                _.each(parentObj.data.dashboard instanceof Array ? parentObj.data.dashboard : [parentObj.data.dashboard], (dashboardSpec, index) => {
                    $stateProvider.state(parentName + '.scope-dashboard-$index' + index, {
                        url: (dashboardSpec.url || '/dashboard') + '?source&view&int',
                        template: '<wf-manage-scope-dashboard'
							+ ' hierarchy-structure-id="vm.hierarchyStructureId"'
							+ ' category-structure-id="vm.categoryStructureId"'
							+ ' permissions-structure-id="vm.permissionsStructureId"'
							+ ' source-network-id="vm.networkId"'
							+ ' config="vm.config"'
							+ ' views-structure-id="vm.viewsStructureId"'
							+ ' sources-structure-id="vm.sourcesStructureId"'
							+ '></wf-manage-scope-dashboard>',
                        controllerAs: 'vm',
                        controller: ['$scope', '$stateParams', '$state', 'valueChainService', function ($scope, $stateParams, $state, valueChainService) {
                            const
                                vm = this

                            const data = $state.current.data.dashboard instanceof Array ? $state.current.data.dashboard[parseInt($state.current.name.split('$index')[1])] : $state.current.data.dashboard

                            vm.networkId = $stateParams.source ? parseInt($stateParams.source) : undefined
                            vm.hierarchyStructureId = $stateParams.view ? parseInt($stateParams.view) : (getValue(data.hierarchyStructureId, enums) || -1)
                            vm.categoryStructureId = $stateParams.int === '0' ? undefined : getValue(data.categoryStructureId, enums)
                            vm.sourcesStructureId = getValue(data.sourcesStructureId, valueChainService)
                            vm.permissionsStructureId = getValue(data.permissionsStructureId, enums)
                            vm.config = getValue(data.config, enums)
                            vm.viewsStructureId = getValue(data.viewsStructureId, enums)

                        }],
                    })
                })
            })

            function getValue(value, objWithIds) {
                // objWithIds can be 'enums' or 'valueChainService'

                if (!value) return undefined
                else if (typeof value === 'number' || typeof value === 'object') return value
                else return _.get(objWithIds, value)
            }

        }

        function configEnterpriseLogins() {
            const enterpriseLoginSpecs = getEnterpriseLoginSpecifications()

            _.map(enterpriseLoginSpecs, (item) => {
                $stateProvider.state(item.routeStateName, {
                    url: item.loginUrl + '?redirect',
                    controller: ['$scope', '$rootScope', 'wfAuth', 'responsiveUi', '$state', '$stateParams', function ($scope, $rootScope, wfAuth, responsiveUi, $state, $stateParams) {
                        responsiveUi.enableResponsiveness()
                        responsiveUi.disableResponsivenessOnScopeDestroy($scope)

                        $rootScope.setPageTitle('Login')
                        $rootScope.$broadcast('auth0.logout')
                        localStorage.setItem('login_state', item.routeStateName)

                        let lockOptions

                        if (item.connection) {
                            lockOptions = {
                                allowedConnections: [item.connection],
                            }
                        }

                        if (item.lockOptions) {
                            lockOptions = { ...(lockOptions || {}), ...item.lockOptions }
                        }

                        localStorage.removeItem('redirectPathAfterLogin')

                        if ($stateParams.redirect) {
                            localStorage.setItem('redirectPathAfterLogin', $stateParams.redirect)
                        }

                        wfAuth.signIn({ lockOptions })
                    }],
                })
            })
        }
    }
})()
